(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7598],{

/***/ 21514:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tekne-turlari/[slug]",
      function () {
        return __webpack_require__(25730);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 39279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36840);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var components_common_BButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87114);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88082);




var DemandPagination = function(param) {
    var totalPages = param.totalPages, page = param.page, changePage = param.changePage;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("common").t;
    return totalPages > 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex items-center justify-end gap-2",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mr-2 inline-block",
                children: t("page")
            }),
            (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Array(totalPages)).map(function(_, idx) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_BButton__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    variant: page === idx ? "primary" : "secondary",
                    priority: "text",
                    className: page === idx ? "underline" : "",
                    onClick: function() {
                        return changePage(idx);
                    },
                    children: +idx + 1
                }, idx);
            })
        ]
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (DemandPagination);


/***/ }),

/***/ 24988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_common_BBadge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24800);
/* harmony import */ var components_common_BImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69327);
/* harmony import */ var components_common_CurrencyText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95269);
/* harmony import */ var hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43617);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88082);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26420);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32466);
/* harmony import */ var styles_ExperienceCard_module_css__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(97890);
/* harmony import */ var styles_ExperienceCard_module_css__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(styles_ExperienceCard_module_css__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48063);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(10520);
/* harmony import */ var components_common_Favourited__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(76417);
/* harmony import */ var components_common_RatingStar__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(31399);
/* harmony import */ var utils_experience_experienceDuration_util__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(70379);
/* harmony import */ var states_useFavorite_store__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(80810);
/* harmony import */ var hooks_useFavorite__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(61356);
/* harmony import */ var states_useUserState__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(13253);
/* harmony import */ var next_translate_routes__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(22742);
/* harmony import */ var next_translate_routes__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(next_translate_routes__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var hooks_usePrevLink__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(3638);
/* harmony import */ var services_AnalyticsService__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(40515);
/* harmony import */ var services_LinkService__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(41824);
/* harmony import */ var hooks_useLocale__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(74021);

























var ExperienceCard = function(param) {
    var containerClass = param.containerClass, _isFirstImagePrioritized = param.isFirstImagePrioritized, isFirstImagePrioritized = _isFirstImagePrioritized === void 0 ? false : _isFirstImagePrioritized, experience = param.experience;
    var ref;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("common").t;
    var asPath = (0,next_translate_routes__WEBPACK_IMPORTED_MODULE_19__.useRouter)().asPath;
    var getPrevLink = (0,hooks_usePrevLink__WEBPACK_IMPORTED_MODULE_20__/* .usePrevLink */ .B)().getPrevLink;
    var isMobile = (0,hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_5__/* .useBreakpoint */ .G)().isMobile;
    var ref1 = (0,utils_experience_experienceDuration_util__WEBPACK_IMPORTED_MODULE_15__/* .getExperienceDurationByTime */ .x)(experience.duration), hour = ref1.hour, minute = ref1.minute;
    var isUserLoggedIn = (0,states_useUserState__WEBPACK_IMPORTED_MODULE_18__/* .useUserState */ .e)().isUserLoggedIn;
    var getExperienceFavorited = (0,states_useFavorite_store__WEBPACK_IMPORTED_MODULE_16__/* .useFavoriteStore */ .E)().getExperienceFavorited;
    var locale = (0,hooks_useLocale__WEBPACK_IMPORTED_MODULE_23__/* .useLocale */ .b)().locale;
    var analyticsPayload = (0,react__WEBPACK_IMPORTED_MODULE_8__.useMemo)(function() {
        return {
            experienceId: experience.id,
            experienceName: experience.title,
            experienceCategory: experience.type,
            regionTrName: "",
            asPathOfPreviousPage: getPrevLink()
        };
    }, [
        experience,
        asPath
    ]);
    var isFavorited = isUserLoggedIn && (experience.isFavorited || getExperienceFavorited(experience.id));
    var ref2 = (0,hooks_useFavorite__WEBPACK_IMPORTED_MODULE_17__/* .useFavorite */ .s)(isFavorited, undefined, analyticsPayload), isCurrentFavorited = ref2.isCurrentFavorited, toggleExperienceFavorite = ref2.toggleExperienceFavorite;
    var sendAnalytics = function() {
        services_AnalyticsService__WEBPACK_IMPORTED_MODULE_21__/* .analyticsService.experienceCardClick */ .I.experienceCardClick(analyticsPayload);
    };
    var linkConstructor = function() {
        return services_LinkService__WEBPACK_IMPORTED_MODULE_22__/* .linkService.getExperienceLink */ .k.getExperienceLink(experience.title, experience.id, locale);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "translate-z-0 absolute top-1.5 z-10 flex w-full items-center justify-between px-1.5",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_BBadge__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: "shadow-sm shadow-slate-500",
                        variant: "info",
                        contrasted: true,
                        children: t("vehicleImmediatelyReservable")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "transform cursor-pointer rounded-full duration-200 ease-in",
                        onClick: function() {
                            return toggleExperienceFavorite(experience.id);
                        },
                        tabIndex: -1,
                        role: "button",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_Favourited__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            isCurrentFavorited: isCurrentFavorited
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                href: linkConstructor(),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((styles_ExperienceCard_module_css__WEBPACK_IMPORTED_MODULE_24___default().container), containerClass),
                    target: isMobile ? "" : "_blank",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_ExperienceCard_module_css__WEBPACK_IMPORTED_MODULE_24___default().image),
                            onClick: sendAnalytics,
                            role: "presentation",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_12__/* .Swiper */ .tq, {
                                modules: [
                                    swiper__WEBPACK_IMPORTED_MODULE_9__/* .Pagination */ .tl
                                ],
                                pagination: {
                                    clickable: true,
                                    dynamicBullets: true,
                                    dynamicMainBullets: 5
                                },
                                spaceBetween: 0,
                                slidesPerView: 1,
                                children: experience.images.map(function(image, idx) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_12__/* .SwiperSlide */ .o5, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_BImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            src: image,
                                            height: 240,
                                            width: 300,
                                            alt: "".concat(experience.title, "-idx"),
                                            className: "object-cover",
                                            priority: isFirstImagePrioritized && idx === 0
                                        })
                                    }, "".concat(image, "-").concat(idx));
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "mb-1 flex items-start justify-between",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "text-sm",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-base font-medium",
                                                children: experience.title
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "flex shrink-0 items-center",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_RatingStar__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                                commentCount: experience.reviewCount || 0,
                                                rating: experience.overallRating || 0,
                                                size: 16,
                                                small: true
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "text-sm text-slate-500",
                                    children: [
                                        "Tur s\xfcresi: ",
                                        hour ? "".concat(hour, " ").concat(t("experience.hour"), " ") : "",
                                        minute ? "".concat(minute, " ").concat(t("experience.minute"), " ") : ""
                                    ]
                                }),
                                !((ref = experience.sessionSummary) === null || ref === void 0 ? void 0 : ref.price) ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_CurrencyText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            className: "text-lg",
                                            price: experience.sessionSummary.price.amount,
                                            currency: experience.sessionSummary.price.currency
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "text-lg text-slate-500",
                                            children: [
                                                "/",
                                                t("units.headCount")
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ExperienceCard);


/***/ }),

/***/ 15010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Seo_SeoWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85157);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(28525);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(44926);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var next_script = __webpack_require__(67320);
var script_default = /*#__PURE__*/__webpack_require__.n(next_script);
// EXTERNAL MODULE: ./node_modules/react-helmet/es/Helmet.js
var Helmet = __webpack_require__(40686);
;// CONCATENATED MODULE: ./src/components/Seo/SeoContent.tsx

var SeoContent = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "seo-content prose prose-slate relative mx-auto w-full max-w-none",
            dangerouslySetInnerHTML: {
                __html: content
            }
        })
    });
};
/* harmony default export */ var Seo_SeoContent = (SeoContent);

;// CONCATENATED MODULE: ./src/components/Seo/SeoWrapper.tsx







var SeoWrapper = function(param) {
    var children = param.children, helmetSettings = param.helmetSettings, content = param.content;
    var title = helmetSettings.title, script = helmetSettings.script, restHelmetSettings = (0,_object_without_properties/* default */.Z)(helmetSettings, [
        "title",
        "script"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Helmet/* Helmet */.q, (0,_object_spread/* default */.Z)({}, restHelmetSettings)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: title
                })
            }),
            script ? /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "schema",
                type: "application/ld+json",
                strategy: "beforeInteractive",
                dangerouslySetInnerHTML: {
                    __html: script
                }
            }) : null,
            children,
            content ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo_SeoContent, {
                content: content
            }) : null
        ]
    });
};
/* harmony default export */ var Seo_SeoWrapper = (SeoWrapper);


/***/ }),

/***/ 24800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80072);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var utils_cn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80207);



var BBadge = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "primary" : _variant, children = param.children, className = param.className, _contrasted = param.contrasted, contrasted = _contrasted === void 0 ? false : _contrasted;
    var classesByVariant = {
        primary: "text-primary-900 bg-primary-100",
        secondary: "text-slate-900 bg-slate-100",
        success: "text-success-900 bg-success-100",
        danger: "text-danger-900 bg-danger-100",
        warning: "text-warning-900 bg-warning-100",
        info: "text-info-900 bg-info-100"
    };
    var contrastedClasses = {
        primary: "bg-primary-600 text-white",
        secondary: "bg-slate-600 text-white",
        success: "bg-success-600 text-white",
        danger: "bg-danger-600 text-white",
        warning: "bg-warning-600 text-white",
        info: "bg-info-600 text-white"
    };
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: (0,utils_cn__WEBPACK_IMPORTED_MODULE_1__.cn)("inline-block rounded-full px-3 py-1.5 text-xs md:text-sm", (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, classesByVariant[variant], !contrasted), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, contrastedClasses[variant], contrasted), _obj), className),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BBadge);


/***/ }),

/***/ 95269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_CurrencyText; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/hooks/useNumberFormat.ts
var useNumberFormat = __webpack_require__(58795);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85157);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18098);
// EXTERNAL MODULE: ./src/enums/currency.ts
var currency = __webpack_require__(85032);
// EXTERNAL MODULE: ./src/services/CookieService.ts
var CookieService = __webpack_require__(79925);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js + 1 modules
var esm = __webpack_require__(15578);
// EXTERNAL MODULE: ./node_modules/zustand/esm/middleware.js
var middleware = __webpack_require__(52500);
;// CONCATENATED MODULE: ./src/states/useCurrencyState.ts






var useCurrencyState = (0,esm/* default */.ZP)()((0,middleware/* devtools */.mW)(function(set) {
    return {
        currency: CookieService/* cookieService.getCookie */._.getCookie("currency", {}) || currency/* Currency.TRY */.F.TRY,
        setCurrency: function(val) {
            return set(function(state) {
                CookieService/* cookieService.setCookie */._.setCookie("currency", val, {});
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    currency: val
                });
            });
        }
    };
}));

;// CONCATENATED MODULE: ./src/components/common/CurrencyText.tsx





var CurrencyText = /*#__PURE__*/ (0,react.memo)(function CurrencyText(param) {
    var price = param.price, propCurrency = param.currency, className = param.className;
    var ref = useCurrencyState(), stateCurrency = ref.currency;
    var priceFormat = (0,useNumberFormat/* useNumberFormat */.h)().priceFormat;
    var localizedPrice = priceFormat(price, propCurrency !== null && propCurrency !== void 0 ? propCurrency : stateCurrency);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: classnames_default()(className),
        children: localizedPrice
    });
});
/* harmony default export */ var common_CurrencyText = (CurrencyText);


/***/ }),

/***/ 76417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var _CdnSvg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76307);


var Favourited = function(param) {
    var isCurrentFavorited = param.isCurrentFavorited, _size = param.size, size = _size === void 0 ? 32 : _size, _isPrimary = param.isPrimary, isPrimary = _isPrimary === void 0 ? false : _isPrimary;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CdnSvg__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        alt: isCurrentFavorited ? "remove favourite" : "favourite",
        className: "max-w-none drop-shadow-md transition-[transform] duration-100 ease-in active:scale-90",
        src: isCurrentFavorited ? "favourite".concat(isPrimary ? "-primary" : "", "-fill.svg") : "favourite".concat(isPrimary ? "-primary" : "", ".svg"),
        size: size
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Favourited);


/***/ }),

/***/ 30013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);
/* harmony import */ var utils_cn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80207);
/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71016);




var ModalWithActivator = function(param) {
    var activator = param.activator, children = param.children, activatorClass = param.activatorClass, modalClass = param.modalClass, modalTitle = param.modalTitle;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), show = ref[0], setShow = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                onClick: function() {
                    return setShow(true);
                },
                className: (0,utils_cn__WEBPACK_IMPORTED_MODULE_2__.cn)("mx-auto w-max cursor-pointer", activatorClass),
                role: "presentation",
                children: activator
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                modalClass: modalClass,
                modalTitle: modalTitle,
                setShow: setShow,
                show: show,
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ModalWithActivator);


/***/ }),

/***/ 31399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var hooks_useNumberFormat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58795);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88082);
/* harmony import */ var utils_cn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80207);
/* harmony import */ var _CdnSvg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76307);





var RatingStar = function(param) {
    var rating = param.rating, commentCount = param.commentCount, _hideCommentCount = param.hideCommentCount, hideCommentCount = _hideCommentCount === void 0 ? false : _hideCommentCount, _size = param.size, size = _size === void 0 ? 24 : _size, _small = param.small, small = _small === void 0 ? false : _small;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("common").t;
    var numberLocaleFormat = (0,hooks_useNumberFormat__WEBPACK_IMPORTED_MODULE_1__/* .useNumberFormat */ .h)().numberLocaleFormat;
    var sizeClass = small ? "text-xs" : "text-sm md:text-base";
    var gapClass = small ? "gap-1" : "gap-2";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,utils_cn__WEBPACK_IMPORTED_MODULE_3__.cn)("flex items-center", gapClass),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CdnSvg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                src: "star-fill.svg",
                size: size,
                alt: "rating-star"
            }),
            !rating || isNaN(rating) ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: sizeClass,
                children: numberLocaleFormat(rating)
            }),
            hideCommentCount ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (0,utils_cn__WEBPACK_IMPORTED_MODULE_3__.cn)("text-slate-500 md:inline", sizeClass),
                children: "(".concat(t("totalCommentCount", {
                    count: commentCount
                }), ")")
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RatingStar);


/***/ }),

/***/ 11455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36840);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32852);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48063);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10520);








var ResponsiveCarousel = function(param) {
    var className = param.className, children = param.children, _pagination = param.pagination, pagination = _pagination === void 0 ? false : _pagination, _slidesPerView = param.slidesPerView, slidesPerView = _slidesPerView === void 0 ? "auto" : _slidesPerView, _spaceBetween = param.spaceBetween, spaceBetween = _spaceBetween === void 0 ? undefined : _spaceBetween, _spacing = param.spacing, spacing = _spacing === void 0 ? "px-2" : _spacing, onSlideChange = param.onSlideChange;
    var modules = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(pagination ? [
        swiper__WEBPACK_IMPORTED_MODULE_3__/* .Pagination */ .tl
    ] : []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("responsive-carousel w-full", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .tq, {
            modules: modules,
            pagination: pagination ? {
                clickable: true,
                dynamicBullets: true,
                dynamicMainBullets: 5
            } : false,
            spaceBetween: spaceBetween,
            slidesPerView: slidesPerView,
            onSlideChange: onSlideChange,
            children: react__WEBPACK_IMPORTED_MODULE_2__.Children.map(children, function(child) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("mx-auto first:pl-0 last:pr-0", spacing),
                    children: child
                });
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ResponsiveCarousel);


/***/ }),

/***/ 74950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ extraUnitTypeLabels; }
/* harmony export */ });
var extraUnitTypeLabels = {
    HEAD_COUNT: "common:units.headCount",
    HOUR: "common:units.hour",
    HOUR_RATE: "common:units.hour",
    RESERVATION: "common:units.reservation",
    DAY: "common:units.day",
    WEEK: "common:units.week"
};


/***/ }),

/***/ 85032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Currency; }
/* harmony export */ });
var Currency;
(function(Currency) {
    Currency["USD"] = "USD";
    Currency["EUR"] = "EUR";
    Currency["TRY"] = "TRY";
})(Currency || (Currency = {}));


/***/ }),

/***/ 77997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ ExtraUnitType; }
/* harmony export */ });
var ExtraUnitType;
(function(ExtraUnitType) {
    ExtraUnitType["HOUR"] = "HOUR";
    ExtraUnitType["RESERVATION"] = "RESERVATION";
    ExtraUnitType["HEAD_COUNT"] = "HEAD_COUNT";
    ExtraUnitType["HOUR_RATE"] = "HOUR_RATE";
    ExtraUnitType["DAY"] = "DAY";
    ExtraUnitType["WEEK"] = "WEEK";
})(ExtraUnitType || (ExtraUnitType = {}));


/***/ }),

/***/ 63932:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useAuthCheck; }
/* harmony export */ });
/* harmony import */ var enums_authModalMode__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85561);
/* harmony import */ var states_useAuthModalState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31087);
/* harmony import */ var states_useUserState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13253);



function useAuthCheck() {
    var isUserLoggedIn = (0,states_useUserState__WEBPACK_IMPORTED_MODULE_2__/* .useUserState */ .e)().isUserLoggedIn;
    var ref = (0,states_useAuthModalState__WEBPACK_IMPORTED_MODULE_1__/* .useAuthModalState */ .d)(), setAuthMode = ref.setAuthMode, setShowAuthModal = ref.setShowAuthModal;
    var checkLoggedIn = function() {
        if (!isUserLoggedIn) {
            setAuthMode(enums_authModalMode__WEBPACK_IMPORTED_MODULE_0__/* .AuthModalMode.LOGIN */ .g.LOGIN);
            setShowAuthModal(true);
        }
        return isUserLoggedIn;
    };
    return {
        checkLoggedIn: checkLoggedIn
    };
}


/***/ }),

/***/ 61356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useFavorite; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21017);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36840);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50132);
/* harmony import */ var services_FavoriteService__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32102);
/* harmony import */ var _useAuthCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63932);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32466);
/* harmony import */ var states_useFavorite_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80810);
/* harmony import */ var services_AnalyticsService__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40515);








function useFavorite(isFavorited, analyticsPayload, experienceAnalyticsPayload) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(isFavorited), isCurrentFavorited = ref[0], setIsCurrentFavorited = ref[1];
    var checkLoggedIn = (0,_useAuthCheck__WEBPACK_IMPORTED_MODULE_1__/* .useAuthCheck */ .P)().checkLoggedIn;
    var ref1 = (0,states_useFavorite_store__WEBPACK_IMPORTED_MODULE_3__/* .useFavoriteStore */ .E)(), setFavoritedVehicleIds = ref1.setFavoritedVehicleIds, favoritedVehicleIds = ref1.favoritedVehicleIds, setFavoritedExperienceIds = ref1.setFavoritedExperienceIds, favoritedExperienceIds = ref1.favoritedExperienceIds;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setIsCurrentFavorited(isFavorited);
    }, [
        isFavorited
    ]);
    var toggleFavorite = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(vehicleId) {
            var notChangedState, itemIdx, newFavoritedVehicles, e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!checkLoggedIn()) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        setIsCurrentFavorited(function(f) {
                            return !f;
                        });
                        notChangedState = isCurrentFavorited;
                        if (!notChangedState) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            services_FavoriteService__WEBPACK_IMPORTED_MODULE_0__/* .favoriteService.removeFavorite */ .z.removeFavorite(vehicleId)
                        ];
                    case 2:
                        _state.sent();
                        itemIdx = favoritedVehicleIds.findIndex(function(v) {
                            return v === vehicleId;
                        });
                        if (~itemIdx) {
                            newFavoritedVehicles = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(favoritedVehicleIds);
                            newFavoritedVehicles.splice(itemIdx, 1);
                            setFavoritedVehicleIds(newFavoritedVehicles);
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            services_FavoriteService__WEBPACK_IMPORTED_MODULE_0__/* .favoriteService.addFavorite */ .z.addFavorite(vehicleId)
                        ];
                    case 4:
                        _state.sent();
                        analyticsPayload && services_AnalyticsService__WEBPACK_IMPORTED_MODULE_4__/* .analyticsService.addToFavorite */ .I.addToFavorite(analyticsPayload);
                        setFavoritedVehicleIds((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(favoritedVehicleIds).concat([
                            vehicleId
                        ]));
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        e = _state.sent();
                        setIsCurrentFavorited(function(f) {
                            return !f;
                        });
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function toggleFavorite(vehicleId) {
            return _ref.apply(this, arguments);
        };
    }();
    var toggleExperienceFavorite = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(vehicleId) {
            var notChangedState, itemIdx, newFavoritedExperiences, e;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!checkLoggedIn()) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        setIsCurrentFavorited(function(f) {
                            return !f;
                        });
                        notChangedState = isCurrentFavorited;
                        if (!notChangedState) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            services_FavoriteService__WEBPACK_IMPORTED_MODULE_0__/* .favoriteService.removeExperienceFavorite */ .z.removeExperienceFavorite(vehicleId)
                        ];
                    case 2:
                        _state.sent();
                        itemIdx = favoritedExperienceIds.findIndex(function(v) {
                            return v === vehicleId;
                        });
                        if (~itemIdx) {
                            newFavoritedExperiences = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(favoritedExperienceIds);
                            newFavoritedExperiences.splice(itemIdx, 1);
                            setFavoritedExperienceIds(newFavoritedExperiences);
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            services_FavoriteService__WEBPACK_IMPORTED_MODULE_0__/* .favoriteService.addExperienceFavorite */ .z.addExperienceFavorite(vehicleId)
                        ];
                    case 4:
                        _state.sent();
                        experienceAnalyticsPayload && services_AnalyticsService__WEBPACK_IMPORTED_MODULE_4__/* .analyticsService.addToFavoriteExperience */ .I.addToFavoriteExperience(experienceAnalyticsPayload);
                        setFavoritedExperienceIds((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(favoritedExperienceIds).concat([
                            vehicleId
                        ]));
                        _state.label = 5;
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        e = _state.sent();
                        setIsCurrentFavorited(function(f) {
                            return !f;
                        });
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function toggleExperienceFavorite(vehicleId) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        toggleFavorite: toggleFavorite,
        toggleExperienceFavorite: toggleExperienceFavorite,
        isCurrentFavorited: isCurrentFavorited
    };
}


/***/ }),

/***/ 58795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useNumberFormat; }
/* harmony export */ });
/* harmony import */ var hooks_useLocale__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74021);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32466);


function useNumberFormat() {
    var locale = (0,hooks_useLocale__WEBPACK_IMPORTED_MODULE_0__/* .useLocale */ .b)().locale;
    var numberLocaleFormat = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(n) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
            minimumFractionDigits: 1,
            maximumFractionDigits: 2
        };
        return new Intl.NumberFormat(locale, options).format(n);
    }, [
        locale
    ]);
    var priceFormat = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(price, currency) {
        return new Intl.NumberFormat(locale, {
            style: "currency",
            currency: currency
        }).format(price);
    }, [
        locale
    ]);
    return {
        numberLocaleFormat: numberLocaleFormat,
        priceFormat: priceFormat
    };
}


/***/ }),

/***/ 25730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85157);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36840);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./src/components/Seo/SeoWrapper.tsx + 1 modules
var SeoWrapper = __webpack_require__(15010);
// EXTERNAL MODULE: ./src/components/Vehicle/VehicleDetail/VehicleDetailCarouselWrapper.tsx + 2 modules
var VehicleDetailCarouselWrapper = __webpack_require__(8390);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(88082);
// EXTERNAL MODULE: ./src/components/Icons/vehicle/avatar.svg
var avatar = __webpack_require__(3168);
// EXTERNAL MODULE: ./src/components/common/BDivider.tsx
var BDivider = __webpack_require__(81580);
// EXTERNAL MODULE: ./src/components/Icons/vehicle/clockwatch.svg
var clockwatch = __webpack_require__(64874);
// EXTERNAL MODULE: ./src/components/Icons/thunder.svg
var thunder = __webpack_require__(84953);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./node_modules/@phosphor-icons/react/dist/lib/IconBase.es.js + 1 modules
var IconBase_es = __webpack_require__(52867);
;// CONCATENATED MODULE: ./node_modules/@phosphor-icons/react/dist/icons/MapPin.es.js
var A = Object.defineProperty, Z = Object.defineProperties;
var p = Object.getOwnPropertyDescriptors;
var n = Object.getOwnPropertySymbols;
var o = Object.prototype.hasOwnProperty, E = Object.prototype.propertyIsEnumerable;
var l = (t, a, m) => a in t ? A(t, a, { enumerable: !0, configurable: !0, writable: !0, value: m }) : t[a] = m, c = (t, a) => {
  for (var m in a || (a = {}))
    o.call(a, m) && l(t, m, a[m]);
  if (n)
    for (var m of n(a))
      E.call(a, m) && l(t, m, a[m]);
  return t;
}, r = (t, a) => Z(t, p(a));



const h = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M128,60a44,44,0,1,0,44,44A44.05,44.05,0,0,0,128,60Zm0,64a20,20,0,1,1,20-20A20,20,0,0,1,128,124Zm0-112a92.1,92.1,0,0,0-92,92c0,77.36,81.64,135.4,85.12,137.83a12,12,0,0,0,13.76,0,259,259,0,0,0,42.18-39C205.15,170.57,220,136.37,220,104A92.1,92.1,0,0,0,128,12Zm31.3,174.71A249.35,249.35,0,0,1,128,216.89a249.35,249.35,0,0,1-31.3-30.18C80,167.37,60,137.31,60,104a68,68,0,0,1,136,0C196,137.31,176,167.37,159.3,186.71Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M128,24a80,80,0,0,0-80,80c0,72,80,128,80,128s80-56,80-128A80,80,0,0,0,128,24Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,128,136Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ react.createElement("path", { d: "M128,64a40,40,0,1,0,40,40A40,40,0,0,0,128,64Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,128Zm0-112a88.1,88.1,0,0,0-88,88c0,31.4,14.51,64.68,42,96.25a254.19,254.19,0,0,0,41.45,38.3,8,8,0,0,0,9.18,0A254.19,254.19,0,0,0,174,200.25c27.45-31.57,42-64.85,42-96.25A88.1,88.1,0,0,0,128,16Zm0,206c-16.53-13-72-60.75-72-118a72,72,0,0,1,144,0C200,161.23,144.53,209,128,222Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M128,16a88.1,88.1,0,0,0-88,88c0,75.3,80,132.17,83.41,134.55a8,8,0,0,0,9.18,0C136,236.17,216,179.3,216,104A88.1,88.1,0,0,0,128,16Zm0,56a32,32,0,1,1-32,32A32,32,0,0,1,128,72Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M128,66a38,38,0,1,0,38,38A38,38,0,0,0,128,66Zm0,64a26,26,0,1,1,26-26A26,26,0,0,1,128,130Zm0-112a86.1,86.1,0,0,0-86,86c0,30.91,14.34,63.74,41.47,94.94a252.32,252.32,0,0,0,41.09,38,6,6,0,0,0,6.88,0,252.32,252.32,0,0,0,41.09-38c27.13-31.2,41.47-64,41.47-94.94A86.1,86.1,0,0,0,128,18Zm0,206.51C113,212.93,54,163.62,54,104a74,74,0,0,1,148,0C202,163.62,143,212.93,128,224.51Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M128,64a40,40,0,1,0,40,40A40,40,0,0,0,128,64Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,128Zm0-112a88.1,88.1,0,0,0-88,88c0,31.4,14.51,64.68,42,96.25a254.19,254.19,0,0,0,41.45,38.3,8,8,0,0,0,9.18,0A254.19,254.19,0,0,0,174,200.25c27.45-31.57,42-64.85,42-96.25A88.1,88.1,0,0,0,128,16Zm0,206c-16.53-13-72-60.75-72-118a72,72,0,0,1,144,0C200,161.23,144.53,209,128,222Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M128,68a36,36,0,1,0,36,36A36,36,0,0,0,128,68Zm0,64a28,28,0,1,1,28-28A28,28,0,0,1,128,132Zm0-112a84.09,84.09,0,0,0-84,84c0,30.42,14.17,62.79,41,93.62a250,250,0,0,0,40.73,37.66,4,4,0,0,0,4.58,0A250,250,0,0,0,171,197.62c26.81-30.83,41-63.2,41-93.62A84.09,84.09,0,0,0,128,20Zm37.1,172.23A254.62,254.62,0,0,1,128,227a254.62,254.62,0,0,1-37.1-34.81C73.15,171.8,52,139.9,52,104a76,76,0,0,1,152,0C204,139.9,182.85,171.8,165.1,192.23Z" }))
  ]
]), C = (0,react.forwardRef)((t, a) => /* @__PURE__ */ react.createElement(IconBase_es/* default */.Z, r(c({ ref: a }, t), { weights: h })));
C.displayName = "MapPin";


// EXTERNAL MODULE: ./node_modules/@phosphor-icons/react/dist/icons/ArrowsClockwise.es.js
var ArrowsClockwise_es = __webpack_require__(39559);
;// CONCATENATED MODULE: ./node_modules/@phosphor-icons/react/dist/icons/Translate.es.js
var Translate_es_h = Object.defineProperty, H = Object.defineProperties;
var Translate_es_c = Object.getOwnPropertyDescriptors;
var Translate_es_n = Object.getOwnPropertySymbols;
var M = Object.prototype.hasOwnProperty, Translate_es_Z = Object.prototype.propertyIsEnumerable;
var Translate_es_r = (l, e, t) => e in l ? Translate_es_h(l, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : l[e] = t, m = (l, e) => {
  for (var t in e || (e = {}))
    M.call(e, t) && Translate_es_r(l, t, e[t]);
  if (Translate_es_n)
    for (var t of Translate_es_n(e))
      Translate_es_Z.call(e, t) && Translate_es_r(l, t, e[t]);
  return l;
}, Translate_es_A = (l, e) => H(l, Translate_es_c(e));



const Translate_es_E = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M242.73,210.63l-56-112a12,12,0,0,0-21.46,0l-20.52,41A84.2,84.2,0,0,1,106,126.22,107.48,107.48,0,0,0,131.33,68H152a12,12,0,0,0,0-24H100V32a12,12,0,0,0-24,0V44H24a12,12,0,0,0,0,24h83.13A83.69,83.69,0,0,1,88,110.35,84,84,0,0,1,75.6,91a12,12,0,1,0-21.81,10A107.55,107.55,0,0,0,70,126.24,83.54,83.54,0,0,1,24,140a12,12,0,0,0,0,24,107.47,107.47,0,0,0,64-21.07,108.4,108.4,0,0,0,45.39,19.44l-24.13,48.26a12,12,0,1,0,21.46,10.73L143.41,196h65.17l12.68,25.36a12,12,0,1,0,21.47-10.73ZM155.41,172,176,130.83,196.58,172Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M216,184H136l40-80ZM88,127.56h0A95.78,95.78,0,0,0,120,56H56A95.78,95.78,0,0,0,88,127.56Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ react.createElement("path", { d: "M239.15,212.42l-56-112a8,8,0,0,0-14.31,0l-21.71,43.43A88,88,0,0,1,100,126.93,103.65,103.65,0,0,0,127.69,64H152a8,8,0,0,0,0-16H96V32a8,8,0,0,0-16,0V48H24a8,8,0,0,0,0,16h87.63A87.7,87.7,0,0,1,88,116.35a87.74,87.74,0,0,1-19-31,8,8,0,1,0-15.08,5.34A103.63,103.63,0,0,0,76,127a87.55,87.55,0,0,1-52,17,8,8,0,0,0,0,16,103.46,103.46,0,0,0,64-22.08,104.18,104.18,0,0,0,51.44,21.31l-26.6,53.19a8,8,0,0,0,14.31,7.16L140.94,192h70.11l13.79,27.58A8,8,0,0,0,232,224a8,8,0,0,0,7.15-11.58ZM148.94,176,176,121.89,203.05,176Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M160,129.89,175.06,160H144.94l6.36-12.7v0ZM224,48V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM207.16,188.42l-40-80a8,8,0,0,0-14.32,0L139.66,134.8a62.31,62.31,0,0,1-23.61-10A79.61,79.61,0,0,0,135.6,80H152a8,8,0,0,0,0-16H112V56a8,8,0,0,0-16,0v8H56a8,8,0,0,0,0,16h63.48a63.73,63.73,0,0,1-15.3,34.05,65.93,65.93,0,0,1-9-13.61,8,8,0,0,0-14.32,7.12,81.75,81.75,0,0,0,11.4,17.15A63.62,63.62,0,0,1,56,136a8,8,0,0,0,0,16,79.56,79.56,0,0,0,48.11-16.13,78.33,78.33,0,0,0,28.18,13.66l-19.45,38.89a8,8,0,0,0,14.32,7.16L136.94,176h46.12l9.78,19.58a8,8,0,1,0,14.32-7.16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M237.37,213.32l-56-112a6,6,0,0,0-10.74,0l-22.3,44.6A90,90,0,0,1,97,127.19,101.73,101.73,0,0,0,125.82,62H152a6,6,0,0,0,0-12H94V32a6,6,0,0,0-12,0V50H24a6,6,0,0,0,0,12h89.79A89.71,89.71,0,0,1,88,119.23,89.81,89.81,0,0,1,67.11,86,6,6,0,1,0,55.8,90,101.66,101.66,0,0,0,79,127.2,89.56,89.56,0,0,1,24,146a6,6,0,0,0,0,12,101.55,101.55,0,0,0,64-22.63,102.11,102.11,0,0,0,54.53,22.17l-27.89,55.78a6,6,0,0,0,10.74,5.36L139.71,190h72.58l14.34,28.68A6,6,0,0,0,232,222a5.87,5.87,0,0,0,2.68-.64A6,6,0,0,0,237.37,213.32ZM145.71,178,176,117.42,206.29,178Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M239.15,212.42l-56-112a8,8,0,0,0-14.31,0l-21.71,43.43A88,88,0,0,1,100,126.93,103.65,103.65,0,0,0,127.69,64H152a8,8,0,0,0,0-16H96V32a8,8,0,0,0-16,0V48H24a8,8,0,0,0,0,16h87.63A87.76,87.76,0,0,1,88,116.35a87.74,87.74,0,0,1-19-31,8,8,0,1,0-15.08,5.34A103.63,103.63,0,0,0,76,127a87.55,87.55,0,0,1-52,17,8,8,0,0,0,0,16,103.46,103.46,0,0,0,64-22.08,104.18,104.18,0,0,0,51.44,21.31l-26.6,53.19a8,8,0,0,0,14.31,7.16L140.94,192h70.11l13.79,27.58A8,8,0,0,0,232,224a8,8,0,0,0,7.15-11.58ZM148.94,176,176,121.89,203.05,176Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M235.58,214.21l-56-112a4,4,0,0,0-7.16,0L149.55,148A92.05,92.05,0,0,1,94,127.36,99.68,99.68,0,0,0,123.91,60H152a4,4,0,0,0,0-8H92V32a4,4,0,0,0-8,0V52H24a4,4,0,0,0,0,8h91.91A91.8,91.8,0,0,1,88,122.05,92,92,0,0,1,65.23,86.67a4,4,0,1,0-7.54,2.66,99.59,99.59,0,0,0,24.3,38A91.59,91.59,0,0,1,24,148a4,4,0,0,0,0,8,99.54,99.54,0,0,0,64-23.21,100.09,100.09,0,0,0,57.66,23l-29.22,58.43a4,4,0,0,0,7.16,3.58L138.47,188h75.06l14.89,29.79A4,4,0,0,0,232,220a4.12,4.12,0,0,0,1.79-.42A4,4,0,0,0,235.58,214.21ZM142.47,180,176,112.94,209.53,180Z" }))
  ]
]), V = (0,react.forwardRef)((l, e) => /* @__PURE__ */ react.createElement(IconBase_es/* default */.Z, Translate_es_A(m({ ref: e }, l), { weights: Translate_es_E })));
V.displayName = "Translate";


// EXTERNAL MODULE: ./src/components/Vehicle/VehicleDetail/VehicleDetailTitledSection.tsx
var VehicleDetailTitledSection = __webpack_require__(61434);
// EXTERNAL MODULE: ./src/utils/experience/experienceDuration.util.ts
var experienceDuration_util = __webpack_require__(70379);
;// CONCATENATED MODULE: ./src/components/Experience/ExperienceDetailGeneralInfo.tsx







var ExperienceDetailGeneralInfo = function(param) {
    var duration = param.duration, cancellationPolicy = param.cancellationPolicy, supportedLanguages = param.supportedLanguages, harbor = param.harbor;
    var t = (0,useTranslation/* default */.Z)("experience").t;
    var ref = (0,experienceDuration_util/* getExperienceDurationByTime */.x)(duration), hour = ref.hour, minute = ref.minute;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleDetailTitledSection/* default */.Z, {
        title: t("generalInfo.title"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(thunder/* default */.Z, {
                            className: "h-8 w-8 flex-shrink-0 fill-primary-500"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: t("generalInfo.items.immediate")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(C, {
                            className: "h-8 w-8 flex-shrink-0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                t("generalInfo.items.harbor"),
                                ": ",
                                harbor
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(clockwatch/* default */.Z, {
                            className: "h-8 w-8 flex-shrink-0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                t("generalInfo.items.duration"),
                                ":",
                                " ",
                                hour ? "".concat(hour, " ").concat(t("common:experience.hour"), " ") : "",
                                " ",
                                minute ? "".concat(minute, " ").concat(t("common:experience.minute"), " ") : ""
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsClockwise_es/* default */.Z, {
                            className: "h-8 w-8 flex-shrink-0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: t("generalInfo.items.cancellationPolicy", {
                                count: cancellationPolicy
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(V, {
                            className: "h-8 w-8 flex-shrink-0"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                t("generalInfo.items.supportedLanguages"),
                                ":",
                                " ",
                                supportedLanguages.map(function(a) {
                                    return t("generalInfo.supportedLanguages.".concat(a));
                                }).join(", ")
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Experience_ExperienceDetailGeneralInfo = (ExperienceDetailGeneralInfo);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(32852);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/common/ResponsiveCarousel.tsx
var ResponsiveCarousel = __webpack_require__(11455);
// EXTERNAL MODULE: ./src/components/Experience/ExperienceCard.tsx
var ExperienceCard = __webpack_require__(24988);
;// CONCATENATED MODULE: ./src/components/Experience/SuggestedExperiences.tsx




var SuggestedExperiences = function(param) {
    var experiences = param.experiences, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classnames_default()("suggested-vehicles flex gap-12", className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveCarousel/* default */.Z, {
            children: experiences.map(function(experience, id) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExperienceCard/* default */.Z, {
                    experience: experience
                }, id);
            })
        })
    });
};
/* harmony default export */ var Experience_SuggestedExperiences = (SuggestedExperiences);

// EXTERNAL MODULE: ./src/components/common/BButton.tsx
var BButton = __webpack_require__(87114);
// EXTERNAL MODULE: ./src/utils/cn.ts
var cn = __webpack_require__(80207);
;// CONCATENATED MODULE: ./src/components/Experience/ExperienceDetailClampTextSection.tsx






var ExperienceDetailClampTextSection = function(param) {
    var className = param.className, description = param.description, title = param.title;
    var t = (0,useTranslation/* default */.Z)("vehicle").t;
    var descriptionRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), showFullContent = ref[0], setShowFullContent = ref[1];
    var ref1 = (0,react.useState)(true), showButton = ref1[0], setShowButton = ref1[1];
    (0,react.useEffect)(function() {
        if (descriptionRef.current && descriptionRef.current.offsetHeight >= descriptionRef.current.scrollHeight) {
            setShowButton(false);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(VehicleDetailTitledSection/* default */.Z, {
        className: (0,cn.cn)("whitespace-pre-line", className),
        title: title,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: descriptionRef,
                className: (0,cn.cn)({
                    "clamp-3-line": !showFullContent
                }),
                children: description
            }),
            showButton ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BButton/* default */.Z, {
                    priority: "none",
                    className: "mt-2 underline md:hover:no-underline",
                    onClick: function() {
                        return setShowFullContent(function(fc) {
                            return !fc;
                        });
                    },
                    children: showFullContent ? t("common:seo.seeLess") : t("common:seo.seeMore")
                })
            }) : null
        ]
    });
};
/* harmony default export */ var Experience_ExperienceDetailClampTextSection = (ExperienceDetailClampTextSection);

;// CONCATENATED MODULE: ./src/components/Experience/ExperienceDetailContact.tsx




var ExperienceDetailContact = function(param) {
    var wrapperClass = param.wrapperClass;
    var t = (0,useTranslation/* default */.Z)().t;
    var ref = (0,react.useState)("Teknevia"), link = ref[0], setLink = ref[1];
    (0,react.useEffect)(function() {
        var ref;
        setLink(window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(VehicleDetailTitledSection/* default */.Z, {
        title: t("experience:doYouHaveAQuestion.title"),
        className: wrapperClass,
        noHeading: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: t("experience:doYouHaveAQuestion.description")
            }),
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: t("experience:doYouHaveAQuestion.link", {
                    link: link
                }),
                target: "doYouHaveAQuestion",
                rel: "noreferrer nofollow",
                className: "underline hover:no-underline",
                children: t("experience:doYouHaveAQuestion.action")
            })
        ]
    });
};
/* harmony default export */ var Experience_ExperienceDetailContact = (ExperienceDetailContact);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(21017);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(50132);
// EXTERNAL MODULE: ./src/components/common/BSkeleton.tsx
var BSkeleton = __webpack_require__(47177);
// EXTERNAL MODULE: ./src/services/DateService.ts
var DateService = __webpack_require__(49163);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(17407);
// EXTERNAL MODULE: ./src/utils/axios.ts + 4 modules
var axios = __webpack_require__(38602);
// EXTERNAL MODULE: ./src/utils/ssrRequestFactory.ts + 2 modules
var ssrRequestFactory = __webpack_require__(32630);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(58382);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./src/services/ExperienceService.ts







var ExperienceService = /*#__PURE__*/ function() {
    "use strict";
    function ExperienceService() {
        (0,_class_call_check/* default */.Z)(this, ExperienceService);
    }
    var _proto = ExperienceService.prototype;
    _proto.getExperienceSSR = function getExperienceSSR(ctx) {
        var ref;
        var splittedUrl = ((ref = ctx.params) === null || ref === void 0 ? void 0 : ref.slug).split("-");
        var experienceId = splittedUrl[splittedUrl.length - 1];
        var sessionId = ctx.query["sessionId"];
        return (0,ssrRequestFactory/* ssrRequest */.e)("/v1/customer/experience/".concat(experienceId), ctx, {
            params: {
                sessionId: sessionId
            }
        });
    };
    _proto.getExperienceSessions = function getExperienceSessions(experienceId, params) {
        return (0,_async_to_generator/* default */.Z)(function() {
            var query, paramsQs, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        query = (0,_object_spread/* default */.Z)({
                            pagination: {
                                page: 0,
                                size: 270,
                                sort: "dateTimeRange.startTime,asc"
                            }
                        }, params);
                        paramsQs = lib_default().stringify(query, {
                            allowDots: true,
                            arrayFormat: "repeat"
                        });
                        return [
                            4,
                            axios/* client.get */.Lp.get("/v1/customer/experience/".concat(experienceId, "/sessions?").concat(paramsQs))
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        })();
    };
    _proto.calculateExperiencePricing = function calculateExperiencePricing(body) {
        return (0,_async_to_generator/* default */.Z)(function() {
            var data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            axios/* client.post */.Lp.post("/v1/customer/experience/calculate-pricing", body)
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        })();
    };
    return ExperienceService;
}();
var experienceService = new ExperienceService();

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18098);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(59354);
;// CONCATENATED MODULE: ./node_modules/@phosphor-icons/react/dist/icons/Confetti.es.js
var Confetti_es_r = Object.defineProperty, Confetti_es_M = Object.defineProperties;
var Confetti_es_A = Object.getOwnPropertyDescriptors;
var Confetti_es_m = Object.getOwnPropertySymbols;
var L = Object.prototype.hasOwnProperty, Confetti_es_o = Object.prototype.propertyIsEnumerable;
var Confetti_es_Z = (l, e, t) => e in l ? Confetti_es_r(l, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : l[e] = t, Confetti_es_n = (l, e) => {
  for (var t in e || (e = {}))
    L.call(e, t) && Confetti_es_Z(l, t, e[t]);
  if (Confetti_es_m)
    for (var t of Confetti_es_m(e))
      Confetti_es_o.call(e, t) && Confetti_es_Z(l, t, e[t]);
  return l;
}, Confetti_es_c = (l, e) => Confetti_es_M(l, Confetti_es_A(e));



const Confetti_es_h = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M114.32,49.8A19.79,19.79,0,0,0,81.72,57L29.22,201.41A19.82,19.82,0,0,0,47.75,228a20,20,0,0,0,6.84-1.22L199,174.28a19.79,19.79,0,0,0,7.24-32.6ZM104.19,183.21l-31.4-31.4L82.94,123.9l49.16,49.16Zm-52.42,26.4Zm12-32.91L79.3,192.26l-24.45,8.89ZM157,164,92,99l10-27.58L184.57,154ZM128,40V16a12,12,0,0,1,24,0V40a12,12,0,0,1-24,0Zm116.48,83.51a12,12,0,0,1-17,17l-16-16a12,12,0,0,1,17-17Zm-.69-40.13-24,8a12,12,0,0,1-7.59-22.77l24-8a12,12,0,1,1,7.59,22.77ZM156.6,65.93C159.83,47.47,173.39,36,192,36c6.45,0,8.69-2.49,10-4.92a18,18,0,0,0,2-7.22V24a12,12,0,0,1,24,0c0,14.47-9.59,36-36,36-4.94,0-10.21,1.19-11.76,10.06A12,12,0,0,1,168.43,80a12.35,12.35,0,0,1-2.08-.18A12,12,0,0,1,156.6,65.93Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(
      "path",
      {
        d: "M58.89,154.89l42.22,42.22-50.63,18.4a7.79,7.79,0,0,1-10-10Zm138.82-4.72L105.83,58.29A7.79,7.79,0,0,0,93,61.14l-14.9,41,75.82,75.82,41-14.9A7.79,7.79,0,0,0,197.71,150.17Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ react.createElement("path", { d: "M111.49,52.63a15.8,15.8,0,0,0-26,5.77L33,202.78A15.83,15.83,0,0,0,47.76,224a16,16,0,0,0,5.46-1l144.37-52.5a15.8,15.8,0,0,0,5.78-26Zm-8.33,135.21-35-35,13.16-36.21,58.05,58.05Zm-55,20,14-38.41,24.45,24.45ZM156,168.64,87.36,100l13-35.87,91.43,91.43ZM160,72a37.8,37.8,0,0,1,3.84-15.58C169.14,45.83,179.14,40,192,40c6.7,0,11-2.29,13.65-7.21A22,22,0,0,0,208,23.94,8,8,0,0,1,224,24c0,12.86-8.52,32-32,32-6.7,0-11,2.29-13.65,7.21A22,22,0,0,0,176,72.06,8,8,0,0,1,160,72ZM136,40V16a8,8,0,0,1,16,0V40a8,8,0,0,1-16,0Zm101.66,82.34a8,8,0,1,1-11.32,11.31l-16-16a8,8,0,0,1,11.32-11.32Zm4.87-42.75-24,8a8,8,0,0,1-5.06-15.18l24-8a8,8,0,0,1,5.06,15.18Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M111.49,52.63a15.8,15.8,0,0,0-26,5.77L33,202.78A15.83,15.83,0,0,0,47.76,224a16,16,0,0,0,5.46-1l144.37-52.5a15.8,15.8,0,0,0,5.78-26ZM65.14,161.13l19.2-52.79,63.32,63.32-52.8,19.2ZM160,72a37.8,37.8,0,0,1,3.84-15.58C169.14,45.83,179.14,40,192,40c6.7,0,11-2.29,13.65-7.21A22,22,0,0,0,208,23.94,8,8,0,0,1,224,24c0,12.86-8.52,32-32,32-6.7,0-11,2.29-13.65,7.21A22,22,0,0,0,176,72.06,8,8,0,0,1,160,72ZM136,40V16a8,8,0,0,1,16,0V40a8,8,0,0,1-16,0Zm101.66,82.34a8,8,0,1,1-11.32,11.31l-16-16a8,8,0,0,1,11.32-11.32Zm4.87-42.75-24,8a8,8,0,0,1-5.06-15.18l24-8a8,8,0,0,1,5.06,15.18Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M110.08,54a13.8,13.8,0,0,0-22.73,5.05L34.85,203.47A13.82,13.82,0,0,0,47.76,222a14,14,0,0,0,4.77-.85l144.38-52.5a13.8,13.8,0,0,0,5-22.73ZM48.43,209.87a1.79,1.79,0,0,1-2.3-2.3L61.31,165.8,90.2,194.68Zm54.21-19.71-36.8-36.81L80.51,113,143,175.49ZM194,156.07a1.74,1.74,0,0,1-1.14,1.3L155.44,171,85,100.55,98.63,63.19a1.72,1.72,0,0,1,1.3-1.14,1.58,1.58,0,0,1,.41,0,1.72,1.72,0,0,1,1.25.53l91.88,91.88A1.73,1.73,0,0,1,194,156.07ZM162,72a35.52,35.52,0,0,1,3.63-14.68C170.57,47.44,179.93,42,192,42c7.47,0,12.53-2.74,15.48-8.38A24.18,24.18,0,0,0,210,24,6,6,0,0,1,216,18h0a6,6,0,0,1,6,6c0,10.38-6.27,30-30,30-7.47,0-12.53,2.74-15.48,8.38A24,24,0,0,0,174,72a6,6,0,0,1-6,6h0A6,6,0,0,1,162,72ZM138,40V16a6,6,0,0,1,12,0V40a6,6,0,0,1-12,0Zm98.24,83.76a6,6,0,1,1-8.48,8.48l-16-16a6,6,0,0,1,8.48-8.48Zm5.66-46.07-24,8a6,6,0,1,1-3.8-11.38l24-8a6,6,0,0,1,3.8,11.38Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M111.49,52.63a15.8,15.8,0,0,0-26,5.77L33,202.78A15.83,15.83,0,0,0,47.76,224a16,16,0,0,0,5.46-1l144.37-52.5a15.8,15.8,0,0,0,5.78-26Zm-8.33,135.21-35-35,13.16-36.21,58.05,58.05Zm-55,20,14-38.41,24.45,24.45ZM156,168.64,87.36,100l13-35.87,91.43,91.43ZM160,72a37.8,37.8,0,0,1,3.84-15.58C169.14,45.83,179.14,40,192,40c6.7,0,11-2.29,13.65-7.21A22,22,0,0,0,208,23.94,8,8,0,0,1,224,24c0,12.86-8.52,32-32,32-6.7,0-11,2.29-13.65,7.21A22,22,0,0,0,176,72.06,8,8,0,0,1,160,72ZM136,40V16a8,8,0,0,1,16,0V40a8,8,0,0,1-16,0Zm101.66,82.34a8,8,0,1,1-11.32,11.31l-16-16a8,8,0,0,1,11.32-11.32Zm4.87-42.75-24,8a8,8,0,0,1-5.06-15.18l24-8a8,8,0,0,1,5.06,15.18Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M108.66,55.46a11.79,11.79,0,0,0-19.43,4.31L36.73,204.15a11.81,11.81,0,0,0,11,15.85,11.88,11.88,0,0,0,4.08-.73l144.38-52.5a11.79,11.79,0,0,0,4.31-19.43Zm-6.53,137L63.52,153.87l16.19-44.51,66.92,66.93Zm-53,19.28a3.81,3.81,0,0,1-4.87-4.87l16.27-44.72,33.32,33.32Zm146.8-55.25a3.77,3.77,0,0,1-2.42,2.74l-38.56,14L82.72,101.07l14-38.56a3.77,3.77,0,0,1,2.74-2.42,4.32,4.32,0,0,1,.85-.09A3.65,3.65,0,0,1,103,61.12L194.88,153A3.78,3.78,0,0,1,195.91,156.51ZM220,24c0,9.68-5.85,28-28,28-8.31,0-14.18,3.29-17.42,9.79A26.12,26.12,0,0,0,172,72a4,4,0,0,1-8,0,34.06,34.06,0,0,1,3.42-13.79C170.66,51.73,177.56,44,192,44c19.29,0,20-18,20-20a4,4,0,0,1,4-4h0A4,4,0,0,1,220,24ZM140,40V16a4,4,0,0,1,8,0V40a4,4,0,0,1-8,0Zm94.83,85.17a4,4,0,0,1-5.66,5.66l-16-16a4,4,0,0,1,5.66-5.66Zm6.43-49.37-24,8A4,4,0,0,1,216,84a4,4,0,0,1-1.27-7.79l24-8a4,4,0,0,1,2.53,7.59Z" }))
  ]
]), Confetti_es_V = (0,react.forwardRef)((l, e) => /* @__PURE__ */ react.createElement(IconBase_es/* default */.Z, Confetti_es_c(Confetti_es_n({ ref: e }, l), { weights: Confetti_es_h })));
Confetti_es_V.displayName = "Confetti";


;// CONCATENATED MODULE: ./node_modules/@phosphor-icons/react/dist/icons/Timer.es.js
var Timer_es_Z = Object.defineProperty, Timer_es_c = Object.defineProperties;
var Timer_es_M = Object.getOwnPropertyDescriptors;
var Timer_es_m = Object.getOwnPropertySymbols;
var Timer_es_h = Object.prototype.hasOwnProperty, Timer_es_o = Object.prototype.propertyIsEnumerable;
var Timer_es_n = (t, a, l) => a in t ? Timer_es_Z(t, a, { enumerable: !0, configurable: !0, writable: !0, value: l }) : t[a] = l, Timer_es_r = (t, a) => {
  for (var l in a || (a = {}))
    Timer_es_h.call(a, l) && Timer_es_n(t, l, a[l]);
  if (Timer_es_m)
    for (var l of Timer_es_m(a))
      Timer_es_o.call(a, l) && Timer_es_n(t, l, a[l]);
  return t;
}, Timer_es_A = (t, a) => Timer_es_c(t, Timer_es_M(a));



const d = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M128,44a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,44Zm0,168a72,72,0,1,1,72-72A72.08,72.08,0,0,1,128,212ZM164.49,99.51a12,12,0,0,1,0,17l-28,28a12,12,0,0,1-17-17l28-28A12,12,0,0,1,164.49,99.51ZM92,16A12,12,0,0,1,104,4h48a12,12,0,0,1,0,24H104A12,12,0,0,1,92,16Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M216,136a88,88,0,1,1-88-88A88,88,0,0,1,216,136Z", opacity: "0.2" }), /* @__PURE__ */ react.createElement("path", { d: "M128,40a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,40Zm0,176a80,80,0,1,1,80-80A80.09,80.09,0,0,1,128,216ZM173.66,90.34a8,8,0,0,1,0,11.32l-40,40a8,8,0,0,1-11.32-11.32l40-40A8,8,0,0,1,173.66,90.34ZM96,16a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,16Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M128,40a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,40Zm45.66,61.66-40,40a8,8,0,0,1-11.32-11.32l40-40a8,8,0,0,1,11.32,11.32ZM96,16a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M128,42a94,94,0,1,0,94,94A94.11,94.11,0,0,0,128,42Zm0,176a82,82,0,1,1,82-82A82.1,82.1,0,0,1,128,218ZM172.24,91.76a6,6,0,0,1,0,8.48l-40,40a6,6,0,1,1-8.48-8.48l40-40A6,6,0,0,1,172.24,91.76ZM98,16a6,6,0,0,1,6-6h48a6,6,0,0,1,0,12H104A6,6,0,0,1,98,16Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M128,40a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,40Zm0,176a80,80,0,1,1,80-80A80.09,80.09,0,0,1,128,216ZM173.66,90.34a8,8,0,0,1,0,11.32l-40,40a8,8,0,0,1-11.32-11.32l40-40A8,8,0,0,1,173.66,90.34ZM96,16a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,16Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M128,44a92,92,0,1,0,92,92A92.1,92.1,0,0,0,128,44Zm0,176a84,84,0,1,1,84-84A84.09,84.09,0,0,1,128,220ZM170.83,93.17a4,4,0,0,1,0,5.66l-40,40a4,4,0,1,1-5.66-5.66l40-40A4,4,0,0,1,170.83,93.17ZM100,16a4,4,0,0,1,4-4h48a4,4,0,0,1,0,8H104A4,4,0,0,1,100,16Z" }))
  ]
]), i = (0,react.forwardRef)((t, a) => /* @__PURE__ */ react.createElement(IconBase_es/* default */.Z, Timer_es_A(Timer_es_r({ ref: a }, t), { weights: d })));
i.displayName = "Timer";


;// CONCATENATED MODULE: ./node_modules/@phosphor-icons/react/dist/icons/ClockClockwise.es.js
var ClockClockwise_es_o = Object.defineProperty, ClockClockwise_es_A = Object.defineProperties;
var ClockClockwise_es_h = Object.getOwnPropertyDescriptors;
var ClockClockwise_es_m = Object.getOwnPropertySymbols;
var ClockClockwise_es_V = Object.prototype.hasOwnProperty, ClockClockwise_es_p = Object.prototype.propertyIsEnumerable;
var ClockClockwise_es_n = (t, a, l) => a in t ? ClockClockwise_es_o(t, a, { enumerable: !0, configurable: !0, writable: !0, value: l }) : t[a] = l, ClockClockwise_es_c = (t, a) => {
  for (var l in a || (a = {}))
    ClockClockwise_es_V.call(a, l) && ClockClockwise_es_n(t, l, a[l]);
  if (ClockClockwise_es_m)
    for (var l of ClockClockwise_es_m(a))
      ClockClockwise_es_p.call(a, l) && ClockClockwise_es_n(t, l, a[l]);
  return t;
}, ClockClockwise_es_r = (t, a) => ClockClockwise_es_A(t, ClockClockwise_es_h(a));



const ClockClockwise_es_d = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M140,80v41.21l34.17,20.5a12,12,0,1,1-12.34,20.58l-40-24A12,12,0,0,1,116,128V80a12,12,0,0,1,24,0Zm84-28a12,12,0,0,0-12,12v7.37c-4.21-4.67-8.58-9.31-13.29-14.08a100,100,0,1,0-2.07,143.44,12,12,0,0,0-16.48-17.46,76,76,0,1,1,1.53-109.06C187.61,80.2,193,86,198.23,92H184a12,12,0,0,0,0,24h40a12,12,0,0,0,12-12V64A12,12,0,0,0,224,52Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M216,128a88,88,0,1,1-88-88A88,88,0,0,1,216,128Z", opacity: "0.2" }), /* @__PURE__ */ react.createElement("path", { d: "M136,80v43.47l36.12,21.67a8,8,0,0,1-8.24,13.72l-40-24A8,8,0,0,1,120,128V80a8,8,0,0,1,16,0Zm88-24a8,8,0,0,0-8,8V82c-6.35-7.36-12.83-14.45-20.12-21.83a96,96,0,1,0-2,137.7,8,8,0,0,0-11-11.64A80,80,0,1,1,184.54,71.4C192.68,79.64,199.81,87.58,207,96H184a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V64A8,8,0,0,0,224,56Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M136,80v43.47l36.12,21.67a8,8,0,0,1-8.24,13.72l-40-24A8,8,0,0,1,120,128V80a8,8,0,0,1,16,0Zm91.06-23.39a8,8,0,0,0-8.72,1.73L206,70.71c-3.23-3.51-6.56-7-10.1-10.59a96,96,0,1,0-2,137.7,8,8,0,0,0-11-11.64A80,80,0,1,1,184.54,71.4c3.54,3.58,6.87,7.1,10.11,10.63L178.34,98.34A8,8,0,0,0,184,112h40a8,8,0,0,0,8-8V64A8,8,0,0,0,227.06,56.61Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M134,80v44.6l37.09,22.25a6,6,0,0,1-6.18,10.3l-40-24A6,6,0,0,1,122,128V80a6,6,0,0,1,12,0Zm90-22a6,6,0,0,0-6,6V87.36c-7.48-8.83-14.94-17.13-23.53-25.83a94,94,0,1,0-1.95,134.83,6,6,0,0,0-8.24-8.72A82,82,0,1,1,186,70c9.24,9.36,17.18,18.3,25.31,28H184a6,6,0,0,0,0,12h40a6,6,0,0,0,6-6V64A6,6,0,0,0,224,58Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M136,80v43.47l36.12,21.67a8,8,0,0,1-8.24,13.72l-40-24A8,8,0,0,1,120,128V80a8,8,0,0,1,16,0Zm88-24a8,8,0,0,0-8,8V82c-6.35-7.36-12.83-14.45-20.12-21.83a96,96,0,1,0-2,137.7,8,8,0,0,0-11-11.64A80,80,0,1,1,184.54,71.4C192.68,79.64,199.81,87.58,207,96H184a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V64A8,8,0,0,0,224,56Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement("path", { d: "M132,80v45.74l38.06,22.83a4,4,0,0,1-4.12,6.86l-40-24A4,4,0,0,1,124,128V80a4,4,0,0,1,8,0Zm92-20a4,4,0,0,0-4,4V92.85C211.33,82.46,203,73,193.05,63a92,92,0,1,0-1.9,132,4,4,0,0,0-5.5-5.82,84,84,0,1,1,1.73-120.5C197.7,79,206.39,89,215.53,100H184a4,4,0,0,0,0,8h40a4,4,0,0,0,4-4V64A4,4,0,0,0,224,60Z" }))
  ]
]), ClockClockwise_es_i = (0,react.forwardRef)((t, a) => /* @__PURE__ */ react.createElement(IconBase_es/* default */.Z, ClockClockwise_es_r(ClockClockwise_es_c({ ref: a }, t), { weights: ClockClockwise_es_d })));
ClockClockwise_es_i.displayName = "ClockClockwise";


// EXTERNAL MODULE: ./src/components/common/BSpinnerInline.tsx
var BSpinnerInline = __webpack_require__(22773);
// EXTERNAL MODULE: ./src/components/common/CurrencyText.tsx + 1 modules
var CurrencyText = __webpack_require__(95269);
// EXTERNAL MODULE: ./src/components/common/ModalWithActivator.tsx
var ModalWithActivator = __webpack_require__(30013);
// EXTERNAL MODULE: ./src/components/common/RatingStar.tsx
var RatingStar = __webpack_require__(31399);
// EXTERNAL MODULE: ./src/components/Form/BDatePicker.tsx
var BDatePicker = __webpack_require__(28933);
// EXTERNAL MODULE: ./src/components/Form/BStepperInput.tsx + 2 modules
var BStepperInput = __webpack_require__(32600);
// EXTERNAL MODULE: ./src/components/Vehicle/VehicleDetail/PriceWidget/PriceWidgetExtraSection.tsx
var PriceWidgetExtraSection = __webpack_require__(50169);
// EXTERNAL MODULE: ./src/components/Vehicle/VehicleDetail/PriceWidget/PriceWidgetExtrasEmptyView.tsx
var PriceWidgetExtrasEmptyView = __webpack_require__(85382);
// EXTERNAL MODULE: ./src/enums/extraUnitTypes.ts
var extraUnitTypes = __webpack_require__(77997);
// EXTERNAL MODULE: ./src/hooks/useForm.ts
var useForm = __webpack_require__(36333);
// EXTERNAL MODULE: ./src/hooks/useLocale.ts
var useLocale = __webpack_require__(74021);
// EXTERNAL MODULE: ./src/hooks/useQueryParams.ts
var useQueryParams = __webpack_require__(78285);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/Trans.js + 1 modules
var Trans = __webpack_require__(25911);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(90935);
// EXTERNAL MODULE: ./src/services/Experience/ExperienceTicketService.ts
var ExperienceTicketService = __webpack_require__(7533);
// EXTERNAL MODULE: ./src/states/useVehicleDetailCommentsModalState.ts
var useVehicleDetailCommentsModalState = __webpack_require__(94553);
// EXTERNAL MODULE: ./node_modules/use-debounce/dist/index.module.js
var index_module = __webpack_require__(78480);
// EXTERNAL MODULE: ./src/utils/getLocalePrefix.ts
var getLocalePrefix = __webpack_require__(14211);
// EXTERNAL MODULE: ./src/utils/noop.ts
var noop = __webpack_require__(24736);
;// CONCATENATED MODULE: ./src/components/Experience/PriceWidget/ExperiencePriceWidgetBody.tsx

































var ExperiencePriceWidgetBody = function(param) {
    var experience = param.experience, sessions = param.sessions, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var locale = (0,useLocale/* useLocale */.b)().locale;
    var t = (0,useTranslation/* default */.Z)("experience").t;
    var ref = (0,experienceDuration_util/* getExperienceDurationByTime */.x)(experience.duration), hour = ref.hour, minute = ref.minute;
    var ref1 = (0,useQueryParams/* useQueryParams */.K)(), addQueryParam = ref1.addQueryParam, getQueryParam = ref1.getQueryParam;
    var setCommentModalVisible = (0,useVehicleDetailCommentsModalState/* useVehicleDetailCommentsModal */.J)().setCommentModalVisible;
    var ref2 = (0,react.useState)(false), _ = ref2[0], setIsCalculatingPricing = ref2[1];
    var ref3 = (0,react.useState)(null), calculatedPricing = ref3[0], setCalculatedPricing = ref3[1];
    var calculatePricing = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(newState) {
            var extras, selectedSession, pricing;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            ,
                            2,
                            3
                        ]);
                        extras = [];
                        if (newState.selectedExtras.length) {
                            selectedSession = newState.selectedSession;
                            newState.selectedExtras.forEach(function(e) {
                                var foundExtra = selectedSession.extras.find(function(a) {
                                    return a.id === e;
                                });
                                if (foundExtra) {
                                    extras.push({
                                        sessionExtraId: foundExtra.experienceExtraServiceId
                                    });
                                }
                            });
                        }
                        setIsCalculatingPricing(true);
                        return [
                            4,
                            experienceService.calculateExperiencePricing({
                                sessionId: newState.selectedSession.id,
                                ticketCount: newState.ticketCount,
                                selectedExtras: extras
                            })
                        ];
                    case 1:
                        pricing = _state.sent();
                        setCalculatedPricing(pricing);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setIsCalculatingPricing(false);
                        return [
                            7
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function calculatePricing(newState) {
            return _ref.apply(this, arguments);
        };
    }();
    var availableSessions = sessions.filter(function(a) {
        return a.availableCapacity > 0 && a.availableCapacity >= a.minimumCapacity && Date.now() < DateService/* dateService.formatServerDateToLocalDate */.o.formatServerDateToLocalDate(a.dateTimeRange.startTime).getTime();
    });
    var dateToSessionMap = (0,react.useMemo)(function() {
        return availableSessions.reduce(function(acc, session) {
            acc[DateService/* dateService.getFormattedDate */.o.getFormattedDate(DateService/* dateService.formatServerDateToLocalDate */.o.formatServerDateToLocalDate(session.dateTimeRange.startTime))] = session;
            return acc;
        }, {});
    }, [
        availableSessions
    ]);
    var firstSession = availableSessions.length ? availableSessions[0] : sessions[0];
    var findSession = function(date) {
        var formattedDate = DateService/* dateService.getFormattedDate */.o.getFormattedDate(date);
        return sessions.find(function(s) {
            var startTime = DateService/* dateService.getFormattedDate */.o.getFormattedDate(DateService/* dateService.formatServerDateToLocalDate */.o.formatServerDateToLocalDate(s.dateTimeRange.startTime));
            return startTime === formattedDate;
        });
    };
    var getDefaultState = (0,react.useCallback)(function() {
        var defaultState = {
            date: DateService/* dateService.formatServerDateToLocalDate */.o.formatServerDateToLocalDate(firstSession.dateTimeRange.startTime),
            ticketCount: 1,
            selectedSession: firstSession,
            selectedExtras: []
        };
        var queryParamState = {
            date: getQueryParam("date"),
            ticketCount: getQueryParam("ticketCount"),
            selectedExtras: getQueryParam("selectedExtras")
        };
        queryParamState.date = isNaN(Number(queryParamState.date)) ? queryParamState.date : Number(queryParamState.date);
        if (queryParamState.date) {
            var formattedQueryDate = DateService/* dateService.getFormattedDate */.o.getFormattedDate(new Date(queryParamState.date));
            var sessionFromQuery = sessions.find(function(s) {
                var startTime = DateService/* dateService.getFormattedDate */.o.getFormattedDate(DateService/* dateService.formatServerDateToLocalDate */.o.formatServerDateToLocalDate(s.dateTimeRange.startTime));
                return startTime === formattedQueryDate;
            });
            if (sessionFromQuery && DateService/* dateService.formatServerDateToLocalDate */.o.formatServerDateToLocalDate(sessionFromQuery.dateTimeRange.startTime).getTime() > Date.now()) {
                defaultState.date = DateService/* dateService.formatServerDateToLocalDate */.o.formatServerDateToLocalDate(sessionFromQuery.dateTimeRange.startTime);
                defaultState.selectedSession = sessionFromQuery;
            }
        }
        if (Number(queryParamState.ticketCount) && !isNaN(Number(queryParamState.ticketCount))) {
            defaultState.ticketCount = Number(queryParamState.ticketCount);
        }
        if (queryParamState.selectedExtras) {
            defaultState.selectedExtras = queryParamState.selectedExtras.map(function(extra) {
                return Number(extra);
            });
        }
        return {
            date: defaultState.date,
            ticketCount: defaultState.ticketCount,
            selectedSession: defaultState.selectedSession,
            selectedExtras: defaultState.selectedExtras
        };
    }, []);
    var disabledExceptDates = (0,react.useMemo)(function() {
        return availableSessions.filter(function(s) {
            return s.availableCapacity > 0;
        }).map(function(s) {
            return DateService/* dateService.getFormattedDate */.o.getFormattedDate(DateService/* dateService.formatServerDateToLocalDate */.o.formatServerDateToLocalDate(s.dateTimeRange.startTime));
        });
    }, [
        availableSessions
    ]);
    var dispatchInterceptor = function(state) {
        var strippedState = {
            date: DateService/* dateService.formatDateToServerDateString */.o.formatDateToServerDateString(state.date),
            ticketCount: state.ticketCount,
            selectedExtras: state.selectedExtras
        };
        addQueryParam(strippedState);
    };
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useForm/* useForm */.c)((0,_object_spread/* default */.Z)({}, getDefaultState()), dispatchInterceptor), 2), state = ref4[0], dispatch = ref4[1];
    var debouncedCalculatePricing = (0,index_module/* useDebouncedCallback */.y1)(calculatePricing, 400);
    (0,react.useEffect)(function() {
        debouncedCalculatePricing(state);
    }, [
        state
    ]);
    (0,react.useEffect)(function() {
        if (state.selectedSession.minimumCapacity > state.ticketCount) {
            dispatch({
                type: "ticketCount",
                payload: state.selectedSession.minimumCapacity
            });
        }
    }, [
        state.selectedSession
    ]);
    var ref5 = (0,react.useState)(false), isSending = ref5[0], setIsSending = ref5[1];
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var foundSession, extras, selectedSession, _amount, ticket;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            ,
                            4,
                            5
                        ]);
                        setIsSending(true);
                        if (!(state.ticketCount > 0)) return [
                            3,
                            3
                        ];
                        foundSession = findSession(state.date);
                        if (!foundSession) return [
                            3,
                            3
                        ];
                        if (!(foundSession.availableCapacity >= state.ticketCount)) return [
                            3,
                            2
                        ];
                        extras = [];
                        if (state.selectedExtras.length) {
                            selectedSession = state.selectedSession;
                            state.selectedExtras.forEach(function(e) {
                                var foundExtra = selectedSession.extras.find(function(a) {
                                    return a.id === e;
                                });
                                if (foundExtra) {
                                    extras.push({
                                        sessionExtraId: foundExtra.experienceExtraServiceId
                                    });
                                }
                            });
                        }
                        return [
                            4,
                            ExperienceTicketService/* experienceTicketService.createTicket */.a.createTicket({
                                experienceId: experience.id,
                                sessionId: foundSession.id,
                                ticketCount: state.ticketCount,
                                totalPrice: (_amount = calculatedPricing === null || calculatedPricing === void 0 ? void 0 : calculatedPricing.totalPrice.amount) !== null && _amount !== void 0 ? _amount : state.ticketCount * foundSession.price.amount,
                                selectedExtras: extras
                            })
                        ];
                    case 1:
                        ticket = _state.sent();
                        window.open("".concat((0,getLocalePrefix/* getLocalePrefix */.A)(locale), "payment/experience/").concat(ticket.ticketId), "_self");
                        return [
                            3,
                            3
                        ];
                    case 2:
                        react_toastify_esm/* toast.error */.Am.error(t("priceWidget.error.capacity"), {
                            toastId: "capacityError"
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsSending(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var singlePricingContainerClasses = "flex justify-between text-medium text-base mt-3";
    var totalPriceClasses = "text-18px font-medium";
    var paymentItemLabelClasses = "text-sm";
    var paymentItemPriceClasses = "text-sm";
    var _amount, _currency, _amount1, _currency1, _amount2, _currency2, ref6, _currency3, _amount3, _currency4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "header flex justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "hourly-price",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyText/* default */.Z, {
                                price: (_amount = calculatedPricing === null || calculatedPricing === void 0 ? void 0 : calculatedPricing.ticketUnitPrice.amount) !== null && _amount !== void 0 ? _amount : state.selectedSession.price.amount,
                                currency: (_currency = calculatedPricing === null || calculatedPricing === void 0 ? void 0 : calculatedPricing.ticketUnitPrice.currency) !== null && _currency !== void 0 ? _currency : state.selectedSession.price.currency,
                                className: "text-2xl"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "price-breakpoint ml-1 inline-block text-lg text-slate-500",
                                children: [
                                    "/",
                                    t("common:units.headCount")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "comments flex items-center gap-2 underline",
                        role: "button",
                        onClick: function() {
                            return setCommentModalVisible(true);
                        },
                        tabIndex: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingStar/* default */.Z, {
                            rating: experience.ratingAverageBundle.overallAverage || 0,
                            commentCount: experience.ratingAverageBundle.reviewCount || 0
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-3 rounded-2xl border border-slate-500",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "border-b border-slate-500 px-3 pb-2.5 pt-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    className: "mb-2 inline-block text-base font-semibold",
                                    htmlFor: "datepicker",
                                    children: t("priceWidget.form.dateLabel")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BDatePicker/* default */.Z, {
                                    sameSizeInMobile: true,
                                    minDetail: "year",
                                    next2Label: null,
                                    prev2Label: null,
                                    calendarClasses: "!top-8 -right-3",
                                    disabledExceptDates: disabledExceptDates,
                                    inputClasses: "text-center naked-input",
                                    minDate: new Date(),
                                    showOnLeft: true,
                                    showTimeInInput: !isMobile,
                                    value: state.date,
                                    onChange: function(val) {
                                        var valDate = DateService/* dateService.getFormattedDate */.o.getFormattedDate(val);
                                        var session = dateToSessionMap[valDate];
                                        if (session) {
                                            dispatch({
                                                type: "selectedSession",
                                                payload: session
                                            });
                                            dispatch({
                                                type: "date",
                                                payload: DateService/* dateService.formatServerDateToLocalDate */.o.formatServerDateToLocalDate(session.dateTimeRange.startTime)
                                            });
                                            return DateService/* dateService.formatServerDateToLocalDate */.o.formatServerDateToLocalDate(session.dateTimeRange.startTime);
                                        }
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "px-3 pb-2.5 pt-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: "mb-2 inline-block text-base font-semibold",
                                htmlFor: "number-of-people",
                                children: t("priceWidget.form.ticketCountLabel")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BStepperInput/* default */.Z, {
                                inputProps: {
                                    id: "number-of-people"
                                },
                                minLimit: state.selectedSession.minimumCapacity || 1,
                                maxLimit: state.selectedSession.availableCapacity,
                                inputEnabled: true,
                                value: state.ticketCount,
                                onChange: function(value) {
                                    return dispatch({
                                        type: "ticketCount",
                                        payload: Number(value)
                                    });
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center pb-2 text-sm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trans/* default */.Z, {
                            i18nKey: "experience:priceWidget.form.minimumCapacity",
                            values: {
                                count: state.selectedSession.minimumCapacity
                            },
                            components: {
                                b: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    className: "px-1"
                                })
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-center py-2",
                children: [
                    t("priceWidget.form.availableTicketCount"),
                    ":\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: state.selectedSession.availableCapacity
                    })
                ]
            }),
            state.selectedSession.extras.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalWithActivator/* default */.Z, {
                modalTitle: t("priceWidget.form.extrasModal.title"),
                activator: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BButton/* default */.Z, {
                    className: "mx-auto mt-4 block text-sm",
                    variant: "info",
                    priority: "contained",
                    type: "button",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Confetti_es_V, {
                            color: "white",
                            size: 16,
                            className: "mr-1 inline-block"
                        }),
                        " ",
                        t("priceWidget.form.extrasModal.title")
                    ]
                }),
                modalClass: "h-screen",
                children: state.selectedSession.extras.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceWidgetExtraSection/* default */.Z, {
                    getChecked: function(val) {
                        return state.selectedExtras.includes(val);
                    },
                    onChange: function(isChecked, value) {
                        dispatch({
                            type: "selectedExtras",
                            payload: value,
                            isAppend: isChecked
                        });
                    },
                    list: state.selectedSession.extras.map(function(extra) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, extra), {
                            unit: extraUnitTypes/* ExtraUnitType.HEAD_COUNT */.q.HEAD_COUNT,
                            price: {
                                amount: extra.price.amount,
                                currency: extra.price.currency,
                                unit: extraUnitTypes/* ExtraUnitType.HEAD_COUNT */.q.HEAD_COUNT
                            }
                        });
                    }),
                    getUnits: function() {
                        return t("common:units.headCount");
                    },
                    withPreline: true,
                    onUnitChange: noop/* noop */.Z
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceWidgetExtrasEmptyView/* default */.Z, {})
            }) : null,
            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "my-5 rounded-lg border border-primary-500 py-3 px-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-4 font-semibold",
                        children: experience.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mb-4 flex flex-col gap-3",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-2 text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(i, {
                                        className: "flex-shrink-0",
                                        size: 20
                                    }),
                                    t("priceWidget.mobile.info.duration"),
                                    ":",
                                    " ",
                                    hour ? "".concat(hour, " ").concat(t("common:experience.hour"), " ") : "",
                                    " ",
                                    minute ? "".concat(minute, " ").concat(t("common:experience.minute"), " ") : ""
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-2 text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ClockClockwise_es_i, {
                                        className: "flex-shrink-0",
                                        size: 20
                                    }),
                                    t("priceWidget.mobile.info.startTime"),
                                    ":",
                                    " ",
                                    DateService/* dateService.getReadableTime */.o.getReadableTime(DateService/* dateService.formatServerDateToLocalDate */.o.formatServerDateToLocalDate(state.selectedSession.dateTimeRange.startTime))
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-2 text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(C, {
                                        className: "flex-shrink-0",
                                        size: 20
                                    }),
                                    t("priceWidget.mobile.info.harbor"),
                                    ": ",
                                    experience.harbor.label
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center gap-2 text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsClockwise_es/* default */.Z, {
                                        className: "flex-shrink-0",
                                        size: 20
                                    }),
                                    t("priceWidget.mobile.info.cancellationPolicy", {
                                        count: experience.cancellationPolicy
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-2 text-sm font-semibold",
                        children: t("whatsIncluded.title")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-sm",
                        children: experience.whatsIncluded
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: singlePricingContainerClasses,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: paymentItemLabelClasses,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyText/* default */.Z, {
                                        price: (_amount1 = calculatedPricing === null || calculatedPricing === void 0 ? void 0 : calculatedPricing.ticketUnitPrice.amount) !== null && _amount1 !== void 0 ? _amount1 : state.selectedSession.price.amount,
                                        currency: (_currency1 = calculatedPricing === null || calculatedPricing === void 0 ? void 0 : calculatedPricing.ticketUnitPrice.currency) !== null && _currency1 !== void 0 ? _currency1 : state.selectedSession.price.currency
                                    }),
                                    " ",
                                    "x ",
                                    state.ticketCount,
                                    " ",
                                    t("common:units.headCount")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyText/* default */.Z, {
                                price: ((_amount2 = calculatedPricing === null || calculatedPricing === void 0 ? void 0 : calculatedPricing.ticketUnitPrice.amount) !== null && _amount2 !== void 0 ? _amount2 : state.selectedSession.price.amount) * state.ticketCount,
                                currency: (_currency2 = calculatedPricing === null || calculatedPricing === void 0 ? void 0 : calculatedPricing.ticketUnitPrice.currency) !== null && _currency2 !== void 0 ? _currency2 : state.selectedSession.price.currency,
                                className: paymentItemPriceClasses
                            })
                        ]
                    }),
                    (calculatedPricing === null || calculatedPricing === void 0 ? void 0 : calculatedPricing.extras.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: singlePricingContainerClasses,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: paymentItemLabelClasses,
                                children: "Toplam Ekstra Hizmet Bedeli"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyText/* default */.Z, {
                                price: (ref6 = calculatedPricing === null || calculatedPricing === void 0 ? void 0 : calculatedPricing.extras.reduce(function(acc, extra) {
                                    return acc + extra.totalPrice.amount;
                                }, 0)) !== null && ref6 !== void 0 ? ref6 : 0,
                                currency: (_currency3 = calculatedPricing === null || calculatedPricing === void 0 ? void 0 : calculatedPricing.ticketUnitPrice.currency) !== null && _currency3 !== void 0 ? _currency3 : state.selectedSession.price.currency,
                                className: paymentItemPriceClasses
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BDivider/* default */.Z, {
                        className: "mt-3",
                        colorClass: "border-primary-900"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: singlePricingContainerClasses,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: totalPriceClasses,
                                children: t("priceWidget.form.pricings.totalAmount")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyText/* default */.Z, {
                                price: (_amount3 = calculatedPricing === null || calculatedPricing === void 0 ? void 0 : calculatedPricing.totalPrice.amount) !== null && _amount3 !== void 0 ? _amount3 : state.selectedSession.price.amount * state.ticketCount,
                                currency: (_currency4 = calculatedPricing === null || calculatedPricing === void 0 ? void 0 : calculatedPricing.totalPrice.currency) !== null && _currency4 !== void 0 ? _currency4 : state.selectedSession.price.currency,
                                className: totalPriceClasses
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BButton/* default */.Z, {
                className: "mt-4",
                fluid: true,
                disabled: isSending,
                onClick: onSubmit,
                children: isSending ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BSpinnerInline/* default */.Z, {
                    size: 24,
                    className: "mx-auto"
                }) : t("priceWidget.form.actions.reserve")
            })
        ]
    });
};
/* harmony default export */ var PriceWidget_ExperiencePriceWidgetBody = (ExperiencePriceWidgetBody);

// EXTERNAL MODULE: ./src/components/Layout/Breakpoint.tsx
var Breakpoint = __webpack_require__(17168);
;// CONCATENATED MODULE: ./src/components/Experience/PriceWidget/ExperiencePriceWidgetDesktop.tsx


var ExperiencePriceWidgetDesktop = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Breakpoint/* default */.Z, {
        type: "min",
        bp: "MD",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "price-widget relative w-[400px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sticky top-2 z-10 w-full min-w-[340px] rounded-md border p-4 shadow-md",
                children: children
            })
        })
    });
};
/* harmony default export */ var PriceWidget_ExperiencePriceWidgetDesktop = (ExperiencePriceWidgetDesktop);

// EXTERNAL MODULE: ./src/components/common/Modal.tsx + 2 modules
var Modal = __webpack_require__(71016);
;// CONCATENATED MODULE: ./src/components/Experience/PriceWidget/ExperiencePriceWidgetMobile.tsx








var ExperiencePriceWidgetMobile = function(param) {
    var children = param.children, sessionsLoading = param.sessionsLoading, sessions = param.sessions;
    var ref;
    var t = (0,useTranslation/* default */.Z)("experience").t;
    var ref1 = (0,react.useState)(false), show = ref1[0], setShow = ref1[1];
    var openModal = (0,react.useCallback)(function() {
        setShow(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Breakpoint/* default */.Z, {
        type: "max",
        bp: "MD",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "fixed bottom-0 left-0 z-400 flex h-[var(--bottom-navigation-menu-height)] w-full items-center justify-between border bg-white px-[var(--padding-container-x)] py-2 shadow-t-lg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "h-6",
                        children: sessionsLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BSkeleton/* default */.Z, {
                            className: "h-6 w-36"
                        }) : ((ref = sessions[0]) === null || ref === void 0 ? void 0 : ref.price.amount) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyText/* default */.Z, {
                                    price: sessions[0].price.amount,
                                    currency: sessions[0].price.currency,
                                    className: "text-lg"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "ml-1 inline-block text-slate-500",
                                    children: [
                                        "/",
                                        t("common:units.headCount")
                                    ]
                                })
                            ]
                        }) : null
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mx-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BButton/* default */.Z, {
                        className: "!py-3",
                        onClick: openModal,
                        disabled: sessionsLoading,
                        children: t("priceWidget.mobile.seeDates")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                    show: show,
                    setShow: setShow,
                    hideWithCss: true,
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ var PriceWidget_ExperiencePriceWidgetMobile = (ExperiencePriceWidgetMobile);

;// CONCATENATED MODULE: ./src/components/Experience/PriceWidget/ExperienceDetailPriceWidget.tsx










var ExperienceDetailPriceWidget = function(param) {
    var experience = param.experience;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)([]), sessions = ref1[0], setSessions = ref1[1];
    var getSessions = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var startDate, res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        startDate = DateService/* dateService.formatDateToServerDateString */.o.formatDateToServerDateString(new Date());
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            experienceService.getExperienceSessions(experience.id, {
                                startDate: startDate
                            })
                        ];
                    case 2:
                        res = _state.sent();
                        setSessions(res.content);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function getSessions() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getSessions();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceWidget_ExperiencePriceWidgetDesktop, {
                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BSkeleton/* default */.Z, {
                    className: "h-8 w-48"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceWidget_ExperiencePriceWidgetBody, {
                    experience: experience,
                    sessions: sessions
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceWidget_ExperiencePriceWidgetMobile, {
                sessions: sessions,
                sessionsLoading: loading,
                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BSkeleton/* default */.Z, {
                    className: "h-8 w-48"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceWidget_ExperiencePriceWidgetBody, {
                    experience: experience,
                    sessions: sessions,
                    isMobile: true
                })
            })
        ]
    });
};
/* harmony default export */ var PriceWidget_ExperienceDetailPriceWidget = (ExperienceDetailPriceWidget);

// EXTERNAL MODULE: ./src/components/common/BImage.tsx
var BImage = __webpack_require__(69327);
// EXTERNAL MODULE: ./src/services/LinkService.ts
var LinkService = __webpack_require__(41824);
// EXTERNAL MODULE: ./src/hooks/useBreadcrumbs.ts
var useBreadcrumbs = __webpack_require__(54865);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/index.js
var next_translate_routes = __webpack_require__(22742);
// EXTERNAL MODULE: ./src/components/common/BBreadcrumb.tsx
var BBreadcrumb = __webpack_require__(73351);
// EXTERNAL MODULE: ./src/enums/locale.ts
var enums_locale = __webpack_require__(42111);
// EXTERNAL MODULE: ./src/lib/seo/seoData.ts
var seoData = __webpack_require__(64978);
// EXTERNAL MODULE: ./src/services/AnalyticsService.ts
var AnalyticsService = __webpack_require__(40515);
// EXTERNAL MODULE: ./src/hooks/usePrevLink.ts
var usePrevLink = __webpack_require__(3638);
// EXTERNAL MODULE: ./src/components/Icons/share.svg
var share = __webpack_require__(48292);
// EXTERNAL MODULE: ./src/hooks/useFavorite.ts
var useFavorite = __webpack_require__(61356);
// EXTERNAL MODULE: ./src/components/common/Favourited.tsx
var Favourited = __webpack_require__(76417);
// EXTERNAL MODULE: ./src/components/Vehicle/VehicleDetail/VehicleDetailShareDropdown.tsx
var VehicleDetailShareDropdown = __webpack_require__(24173);
;// CONCATENATED MODULE: ./src/components/Experience/ExperienceDetailTitle.tsx








var ExperienceDetailTitle = function(param) {
    var experienceName = param.experienceName, harbor = param.harbor, region = param.region, isFavorited = param.isFavorited, experienceId = param.experienceId, addToWishlistPayload = param.addToWishlistPayload;
    var t = (0,useTranslation/* default */.Z)().t;
    var ref = (0,react.useState)(false), shareDropdown = ref[0], setShareDropdown = ref[1];
    var ref1 = (0,useFavorite/* useFavorite */.s)(isFavorited, undefined, addToWishlistPayload), toggleExperienceFavorite = ref1.toggleExperienceFavorite, isCurrentFavorited = ref1.isCurrentFavorited;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "vehicle-title",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full items-center justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-lg font-medium md:text-xl md:font-semibold",
                        children: experienceName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "relative",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BButton/* default */.Z, {
                                        priority: "text",
                                        variant: "secondary",
                                        className: "flex items-center gap-2",
                                        onClick: function() {
                                            return setShareDropdown(true);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(share/* default */.Z, {
                                                className: "w-5"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "hidden md:inline-block",
                                                children: t("vehicle:share")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleDetailShareDropdown/* default */.Z, {
                                        show: shareDropdown,
                                        onClose: function() {
                                            return setShareDropdown(false);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BButton/* default */.Z, {
                                variant: "secondary",
                                priority: "text",
                                onClick: function() {
                                    return toggleExperienceFavorite(experienceId);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center gap-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Favourited/* default */.Z, {
                                            isCurrentFavorited: isCurrentFavorited,
                                            size: 20,
                                            isPrimary: true
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "hidden md:inline-block",
                                            children: t("vehicle:favorite")
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-1 flex w-full items-center justify-between",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "font-medium text-slate-500",
                    children: "".concat(harbor, ", ").concat(region)
                })
            })
        ]
    });
};
/* harmony default export */ var Experience_ExperienceDetailTitle = (ExperienceDetailTitle);

// EXTERNAL MODULE: ./src/components/Vehicle/VehicleDetail/VehicleDetailCommentsItem.tsx
var VehicleDetailCommentsItem = __webpack_require__(90825);
// EXTERNAL MODULE: ./src/components/Vehicle/VehicleDetail/VehicleDetailCommentsSubAverageItem.tsx
var VehicleDetailCommentsSubAverageItem = __webpack_require__(50743);
// EXTERNAL MODULE: ./src/hooks/useFirstRender.ts
var useFirstRender = __webpack_require__(41048);
// EXTERNAL MODULE: ./src/services/Experience/ExperienceRatingService.ts
var ExperienceRatingService = __webpack_require__(64879);
// EXTERNAL MODULE: ./src/components/Demand/DemandPagination.tsx
var DemandPagination = __webpack_require__(39279);
;// CONCATENATED MODULE: ./src/components/Experience/ExperienceDetailCommentsModal.tsx












var ExperienceDetailCommentModal = function(param) {
    var experienceId = param.experienceId;
    var t = (0,useTranslation/* default */.Z)("vehicle").t;
    var ref = (0,useVehicleDetailCommentsModalState/* useVehicleDetailCommentsModal */.J)(), isCommentModalVisible = ref.isCommentModalVisible, setCommentModalVisible = ref.setCommentModalVisible;
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react.useState)([]), comments = ref2[0], setComments = ref2[1];
    var ref3 = (0,react.useState)(0), page = ref3[0], setPage = ref3[1];
    var ref4 = (0,react.useState)(0), totalPages = ref4[0], setTotalPages = ref4[1];
    var getComments = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(page) {
            var res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            ,
                            2,
                            3
                        ]);
                        setLoading(true);
                        return [
                            4,
                            ExperienceRatingService/* experienceRatingService.getExperienceRatings */.t.getExperienceRatings(experienceId, {
                                size: 5,
                                page: page
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        setComments(res.content);
                        setPage(page);
                        setTotalPages(res.totalPages);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function getComments(page) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,useFirstRender/* useFirstRender */.s)(function() {
        getComments(0);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        modalTitle: t("vehicle:commentModalTitle"),
        show: isCommentModalVisible,
        setShow: setCommentModalVisible,
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex h-full min-h-[70vh] w-full items-center justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BSpinnerInline/* default */.Z, {})
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex h-full min-h-[70vh] flex-col justify-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "space-y-8",
                    children: comments.map(function(comment) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleDetailCommentsItem/* default */.Z, {
                            comment: comment.content,
                            // answer={null}
                            commentDate: comment.commentDate,
                            commentor: comment.commentor,
                            title: comment.title,
                            rating: comment.rateBundle.average,
                            className: "mb-6"
                        }, comment.commentId);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DemandPagination/* default */.Z, {
                        changePage: getComments,
                        page: page,
                        totalPages: totalPages
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ExperienceDetailCommentsModal = (ExperienceDetailCommentModal);

;// CONCATENATED MODULE: ./src/components/Experience/ExperienceDetailComments.tsx














var ExperienceDetailComments = function(param) {
    var experience = param.experience;
    var t = (0,useTranslation/* default */.Z)().t;
    var setCommentModalVisible = (0,useVehicleDetailCommentsModalState/* useVehicleDetailCommentsModal */.J)().setCommentModalVisible;
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var ref1 = (0,react.useState)([]), comments = ref1[0], setComments = ref1[1];
    var ref2 = (0,react.useState)(0), totalElements = ref2[0], setTotalElements = ref2[1];
    var getComments = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            ,
                            2,
                            3
                        ]);
                        setLoading(true);
                        return [
                            4,
                            ExperienceRatingService/* experienceRatingService.getExperienceRatings */.t.getExperienceRatings(experience.id, {
                                page: 0,
                                size: 3
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        setComments(res.content);
                        setTotalElements(res.totalElements);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function getComments() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,useFirstRender/* useFirstRender */.s)(function() {
        getComments();
    });
    return loading && !comments.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(VehicleDetailTitledSection/* default */.Z, {
        className: "mt-8 mb-16",
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingStar/* default */.Z, {
                rating: experience.ratingAverageBundle.overallAverage || 0,
                commentCount: experience.ratingAverageBundle.reviewCount || 0
            })
        }),
        noHeading: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-1 gap-4 sm:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleDetailCommentsSubAverageItem/* default */.Z, {
                        average: experience.ratingAverageBundle.hygieneAverage || 0,
                        label: t("common:ratingCategory.hygiene")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleDetailCommentsSubAverageItem/* default */.Z, {
                        average: experience.ratingAverageBundle.serviceAverage || 0,
                        label: t("common:ratingCategory.service")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleDetailCommentsSubAverageItem/* default */.Z, {
                        average: experience.ratingAverageBundle.communicationAverage || 0,
                        label: t("common:ratingCategory.communication")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleDetailCommentsSubAverageItem/* default */.Z, {
                        average: experience.ratingAverageBundle.pricePerformanceAverage || 0,
                        label: t("common:ratingCategory.pricePerformance")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col gap-6",
                        children: comments.map(function(comment) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleDetailCommentsItem/* default */.Z, {
                                comment: comment.content,
                                // answer={undefined}
                                commentDate: comment.commentDate,
                                commentor: comment.commentor,
                                title: comment.title,
                                rating: comment.rateBundle.average
                            }, comment.commentId);
                        })
                    }),
                    totalElements > 3 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "float-right",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BButton/* default */.Z, {
                            variant: "secondary",
                            priority: "text",
                            className: "text-sm",
                            onClick: function() {
                                return setCommentModalVisible(true);
                            },
                            children: t("common:seeMore") + " >"
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExperienceDetailCommentsModal, {
                experienceId: experience.id
            })
        ]
    });
};
/* harmony default export */ var Experience_ExperienceDetailComments = (ExperienceDetailComments);

// EXTERNAL MODULE: ./src/services/LocalizationService.ts
var LocalizationService = __webpack_require__(55389);
;// CONCATENATED MODULE: ./src/pages/tekne-turlari/[slug].tsx




























var Experience = function(param) {
    var experience = param.experience, slugTranslations = param.slugTranslations;
    LocalizationService/* localizationService.slugTranslations */.R.slugTranslations = (0,_object_spread/* default */.Z)({}, slugTranslations);
    var t = (0,useTranslation/* default */.Z)().t;
    var locale = (0,useLocale/* useLocale */.b)().locale;
    var ref = (0,next_translate_routes.useRouter)(), asPath = ref.asPath, slug = ref.query.slug;
    var ref1 = (0,useBreadcrumbs/* useBreadcrumbs */.h)(), defaultBreadcrumbs = ref1.defaultBreadcrumbs, generateCategoryLinks = ref1.generateCategoryLinks;
    var experienceName = experience.title;
    var category = (0,react.useMemo)(function() {
        return LinkService/* linkService.getCategoryLinkOption */.k.getCategoryLinkOption(null, locale, "EXPERIENCE");
    }, [
        experience
    ]);
    var breadcrumbs = (0,_to_consumable_array/* default */.Z)(defaultBreadcrumbs).concat((0,_to_consumable_array/* default */.Z)(generateCategoryLinks(category, experience.seoLocation)), [
        {
            label: experienceName,
            link: asPath,
            isTranslatable: false
        }, 
    ]);
    var getPrevLink = (0,usePrevLink/* usePrevLink */.B)().getPrevLink;
    (0,react.useEffect)(function() {
        AnalyticsService/* analyticsService.experienceDetailPageView */.I.experienceDetailPageView({
            asPathOfPreviousPage: getPrevLink(),
            experienceId: experience.id,
            experienceName: experienceName,
            experienceCategory: experience.type,
            regionTrName: experience.type
        });
    }, [
        slug
    ]);
    var helmetSettings = (0,react.useMemo)(function() {
        var description = t("experience:seo.description", {
            experienceName: experienceName,
            id: experience.id
        });
        var localePrefix = locale === enums_locale/* Locale.EN */.g.EN ? "en/boat-tours" : "tekne-turlari";
        var url = "https://www.teknevia.com/".concat(localePrefix, "/").concat(slug);
        return (0,seoData/* getVehicleHelmetSettings */.vA)(experienceName, description, locale, url, experience.images[0], {
            images: (0,_to_consumable_array/* default */.Z)(experience.images),
            commentCount: experience.ratingAverageBundle.reviewCount || 0,
            ratingCount: experience.ratingAverageBundle.reviewCount || 0,
            name: experienceName,
            description: description,
            category: t("experience:seo.productCategory"),
            rating: Number((experience.ratingAverageBundle.overallAverage || 0).toFixed(2)),
            url: url
        });
    }, [
        t,
        locale
    ]);
    var addToWishlistPayload = (0,react.useMemo)(function() {
        return {
            experienceId: experience.id,
            experienceName: experienceName,
            experienceCategory: experience.type,
            regionTrName: experience.regionTRName,
            asPathOfPreviousPage: getPrevLink()
        };
    }, [
        experience,
        asPath,
        experienceName,
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoWrapper/* default */.Z, {
        helmetSettings: helmetSettings,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: "vehicle-detail touch-pan-y",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(BBreadcrumb/* default */.Z, {
                    breadcrumbItems: breadcrumbs,
                    wrapperClasses: "mb-4"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Experience_ExperienceDetailTitle, {
                    experienceName: experienceName,
                    harbor: experience.harbor.label,
                    region: experience.region.label,
                    isFavorited: experience.isFavorited,
                    experienceId: experience.id,
                    addToWishlistPayload: addToWishlistPayload
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleDetailCarouselWrapper/* default */.Z, {
                    images: experience.images,
                    vehicleName: experienceName,
                    wrapperClass: "my-6"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-8 flex w-full justify-between gap-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                            className: "w-full space-y-8 md:w-[70%]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: experience.description
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BDivider/* default */.Z, {
                                    className: "my-8 w-full"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mb-3",
                                                    children: [
                                                        t("experience:ownerSection.type.label"),
                                                        ":",
                                                        " ",
                                                        t("experience:ownerSection.type.".concat(experience.type))
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        t("experience:ownerSection.ownerLabel"),
                                                        ":",
                                                        " ",
                                                        experience.partner.name
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-12 w-12 shrink-0 overflow-hidden rounded-full",
                                            children: experience.partner.avatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BImage/* default */.Z, {
                                                src: experience.partner.avatar,
                                                alt: experience.partner.name,
                                                objectFit: "cover",
                                                layout: "fixed",
                                                width: 48,
                                                height: 48
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.Z, {
                                                size: 48
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BDivider/* default */.Z, {
                                    className: "my-8 w-full"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Experience_ExperienceDetailGeneralInfo, {
                                    duration: experience.duration,
                                    cancellationPolicy: experience.cancellationPolicy,
                                    supportedLanguages: experience.supportedLanguages,
                                    harbor: experience.harbor.label
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BDivider/* default */.Z, {
                                    className: "my-8 w-full"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Experience_ExperienceDetailClampTextSection, {
                                    title: t("experience:highlights.title"),
                                    description: experience.importantPoints
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BDivider/* default */.Z, {
                                    className: "my-8 w-full"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Experience_ExperienceDetailClampTextSection, {
                                    title: t("experience:fullDescription.title"),
                                    description: experience.fullDescription
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BDivider/* default */.Z, {
                                    className: "my-8 w-full"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Experience_ExperienceDetailClampTextSection, {
                                    title: t("experience:whatsIncluded.title"),
                                    description: experience.whatsIncluded
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BDivider/* default */.Z, {
                                    className: "my-8 w-full"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Experience_ExperienceDetailClampTextSection, {
                                    title: t("experience:neededInfo.title"),
                                    description: experience.neededInfo
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BDivider/* default */.Z, {
                                    className: "my-8 w-full"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Experience_ExperienceDetailClampTextSection, {
                                    title: t("experience:notSuitableFor.title"),
                                    description: experience.notSuitableFor
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BDivider/* default */.Z, {
                                    className: "my-8 w-full"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Experience_ExperienceDetailClampTextSection, {
                                    title: t("experience:routeDescription.title"),
                                    description: experience.routeDescription
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BDivider/* default */.Z, {
                                    className: "my-8 w-full"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Experience_ExperienceDetailContact, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BDivider/* default */.Z, {
                                    className: "my-8 w-full"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceWidget_ExperienceDetailPriceWidget, {
                            experience: experience
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Experience_ExperienceDetailComments, {
                    experience: experience
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VehicleDetailTitledSection/* default */.Z, {
                    title: t("experience:similarExperiences.title"),
                    noHeading: true,
                    className: "mt-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Experience_SuggestedExperiences, {
                        experiences: experience.similarExperiences
                    })
                })
            ]
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var _slug_ = (Experience);


/***/ }),

/***/ 64879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ experienceRatingService; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21017);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17407);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85157);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50132);
/* harmony import */ var utils_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38602);





var ExperienceRatingService = /*#__PURE__*/ function() {
    "use strict";
    function ExperienceRatingService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, ExperienceRatingService);
    }
    var _proto = ExperienceRatingService.prototype;
    _proto.getExperienceRatings = function getExperienceRatings(experienceId, pagination) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            var data;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            utils_axios__WEBPACK_IMPORTED_MODULE_0__/* .client.get */ .Lp.get("/v1/customer/rating/experience/".concat(experienceId, "/comments"), {
                                params: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, pagination)
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        })();
    };
    _proto.rateExperience = function rateExperience(payload) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            utils_axios__WEBPACK_IMPORTED_MODULE_0__/* .client.post */ .Lp.post("/v1/customer/rating/experience", payload)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        })();
    };
    return ExperienceRatingService;
}();
var experienceRatingService = new ExperienceRatingService();


/***/ }),

/***/ 7533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ experienceTicketService; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21017);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17407);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50132);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58382);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var services_DateService__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49163);
/* harmony import */ var types_experience_experience_ticket_type__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59933);
/* harmony import */ var utils_axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38602);
/* harmony import */ var utils_ssrRequestFactory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32630);








var ExperienceTicketService = /*#__PURE__*/ function() {
    "use strict";
    function ExperienceTicketService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, ExperienceTicketService);
    }
    var _proto = ExperienceTicketService.prototype;
    _proto.getExperienceTicketsPayload = function getExperienceTicketsPayload(page) {
        var dayjs = services_DateService__WEBPACK_IMPORTED_MODULE_0__/* .dateService.getDayjs */ .o.getDayjs();
        var basePayload = {
            startDate: services_DateService__WEBPACK_IMPORTED_MODULE_0__/* .dateService.formatDateToServerDateString */ .o.formatDateToServerDateString(dayjs().subtract(1, "year").toDate()),
            endDate: services_DateService__WEBPACK_IMPORTED_MODULE_0__/* .dateService.formatDateToServerDateString */ .o.formatDateToServerDateString(dayjs().add(1, "year").toDate()),
            pagination: {
                page: page,
                size: 5,
                sort: [
                    "timeStamps.createdAt,desc"
                ]
            },
            state: [
                types_experience_experience_ticket_type__WEBPACK_IMPORTED_MODULE_1__/* .ExperienceTicketState.WAITING_DUE_DATE */ .$.WAITING_DUE_DATE,
                types_experience_experience_ticket_type__WEBPACK_IMPORTED_MODULE_1__/* .ExperienceTicketState.ON_GOING */ .$.ON_GOING,
                types_experience_experience_ticket_type__WEBPACK_IMPORTED_MODULE_1__/* .ExperienceTicketState.CANCELLED */ .$.CANCELLED,
                types_experience_experience_ticket_type__WEBPACK_IMPORTED_MODULE_1__/* .ExperienceTicketState.DONE */ .$.DONE, 
            ]
        };
        return qs__WEBPACK_IMPORTED_MODULE_5___default().stringify(basePayload, {
            allowDots: true,
            arrayFormat: "repeat"
        });
    };
    _proto.getExperienceTicketsSSR = function getExperienceTicketsSSR(ctx) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
            var paramsQs;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                paramsQs = experienceTicketService.getExperienceTicketsPayload(0);
                return [
                    2,
                    (0,utils_ssrRequestFactory__WEBPACK_IMPORTED_MODULE_3__/* .ssrRequest */ .e)("/v1/customer/experience/tickets?".concat(paramsQs), ctx)
                ];
            });
        })();
    };
    _proto.getExperienceTickets = function getExperienceTickets(page) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
            var paramsQs, data;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        paramsQs = experienceTicketService.getExperienceTicketsPayload(page);
                        return [
                            4,
                            utils_axios__WEBPACK_IMPORTED_MODULE_2__/* .client.get */ .Lp.get("/v1/customer/experience/tickets?".concat(paramsQs))
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        })();
    };
    _proto.createTicket = function createTicket(payload) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
            var data;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            utils_axios__WEBPACK_IMPORTED_MODULE_2__/* .client.post */ .Lp.post("/v1/customer/experience/tickets", payload)
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        })();
    };
    _proto.cancelTicket = function cancelTicket(ticketId, payload) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
            var data;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            utils_axios__WEBPACK_IMPORTED_MODULE_2__/* .client.put */ .Lp.put("/v1/customer/experience/tickets/".concat(ticketId, "/cancel"), payload)
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            data
                        ];
                }
            });
        })();
    };
    return ExperienceTicketService;
}();
var experienceTicketService = new ExperienceTicketService();


/***/ }),

/***/ 59933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ ExperienceTicketState; }
/* harmony export */ });
var ExperienceTicketState;
(function(ExperienceTicketState) {
    ExperienceTicketState["CREATED"] = "CREATED";
    ExperienceTicketState["PAYMENT_PENDING"] = "PAYMENT_PENDING";
    ExperienceTicketState["WAITING_DUE_DATE"] = "WAITING_DUE_DATE";
    ExperienceTicketState["ON_GOING"] = "ON_GOING";
    ExperienceTicketState["EXPIRED"] = "EXPIRED";
    ExperienceTicketState["CANCELLED"] = "CANCELLED";
    ExperienceTicketState["DONE"] = "DONE";
})(ExperienceTicketState || (ExperienceTicketState = {}));


/***/ }),

/***/ 70379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ getExperienceDurationByTime; }
/* harmony export */ });
/* harmony import */ var services_DateService__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49163);

function getExperienceDurationByTime(duration) {
    var dayjs = services_DateService__WEBPACK_IMPORTED_MODULE_0__/* .dateService.getDayjs */ .o.getDayjs();
    var d = dayjs.duration(duration, "m");
    return {
        hour: d.hours(),
        minute: d.minutes()
    };
}


/***/ }),

/***/ 97890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"ExperienceCard_container__mL7aZ","image":"ExperienceCard_image__7tyRu","dash":"ExperienceCard_dash__rPXnr","star":"ExperienceCard_star__8HzwV"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3457,5867,2879,286,2313,2709,4413,8579,9774,2888,179], function() { return __webpack_exec__(21514); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);